import React, { useEffect, useRef, useState } from "react";
import { useFetchAppointmentTypesMutation } from "../../../../../features/appointment/appointmentApiSlice";
import {
  useCreateProviderLeaveMutation,
  useFetchProviderLeavesMutation,
  useRemoveProviderLeaveMutation,
  useUpdateProviderLeaveMutation,
  useUpsertProviderConstraintMutation,
  useFetchProviderByIdMutation,
  useFetchProviderZonesMutation,
  useAddWeeklyDateRangeMutation,
  useGetWeeklyDateRangeMutation,
  useDeleteWeeklyDateRangeMutation,
  useFetchProviderZipCodesMutation,
  useCreateAvTemplateMutation,
  useDeleteAssignmentMutation,
} from "../../../../../features/provider/providerApiSlice";
import { useFetchZonesMutation } from "../../../../../features/zones/zonesApiSlice";
import "moment-timezone";
import moment from "moment";
import { useSelector } from "react-redux";
import Select from "react-select";
import IconComponent from "../../../../../components/DataTable/Icon";
import ReusableModal from "../../../../../components/Modals/ReusableModal";
import {
  ACTIVITY_STATUS,
  ACTIVITY_TYPE,
} from "../../../../../constants/config.constants";
import { selectUser } from "../../../../../features/auth/authSlice";
import { useCreateLogsMutation } from "../../../../../features/logs/logsApiSlice";
import Calendar from "./Calendar";
import tzlookup from "tz-lookup";
import { FaChevronDown, FaChevronUp, FaLastfmSquare } from "react-icons/fa";
import { capitalizeFirstWords } from "../../../../../utilities/resuseFunctions";
import Snackbar from "@mui/material/Snackbar";
import Alert from "@mui/material/Alert";
import { Tooltip } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { CoPresentOutlined } from "@mui/icons-material";
import WarningRoundedIcon from "@mui/icons-material/WarningRounded";


const days = [
  "MONDAY",
  "TUESDAY",
  "WEDNESDAY",
  "THURSDAY",
  "FRIDAY",
  "SATURDAY",
  "SUNDAY",
];

export const LEAVE_TYPE = {
  GEN: "General",
  PTO: "PTO",
  VACATION: "VACATION",
  MEETING: "MEETING",
  TRAINING: "TRAINING",
  MEDICAL: "SICK",
  ADMINISTRATIVE_TIME: "ADMINISTRATIVE_TIME",
  COMPANY_WIDE_ABSENCE: 'COMPANY_WIDE_ABSENCE'
};

const ProviderSettingsModal = ({
  handleEditClick,
  details,
  providers,
  setProviders,
  screen = "Provider",
  setProviderIsAv,
  setIsCalenderOpen,
  setEditModalOpen,
  showAlert,
}) => {
  // Mock data structure - replace with your actual data

  const [availabilityType, setAvailabilityType] = useState("global"); // "global" or "custom"
  const [selectedDays, setSelectedDays] = useState(details.workingDays);
  // const [visitsPerDay, setVisitsPerDay] = useState(details.visitsPerDay);
  const [dayPreferences, setDayPreferences] = useState(details.dayPreferences);
  const [from, setFrom] = useState(details.startDate);
  const [to, setTo] = useState(details.endDate);

  const [leaves, setLeaves] = useState([]);
  const [appointmentTypes, setAppointmentTypes] = useState([]);
  const [zones, setZones] = useState([]);
  const [zipCodes, setZipCodes] = useState([]);

  const [name, setName] = useState("");
  const [type, setType] = useState("");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [startTime, setStartTime] = useState("");
  const [endTime, setEndTime] = useState("");
  const [description, setDescription] = useState("");

  const [ptoToEdit, setPtoToEdit] = useState(null);

  const [activeTab, setActiveTab] = useState(0);
  const [selectedMarket, setSelectedMarket] = useState(details?.market[0]?.id);
  const [selectedDay, setSelectedDay] = useState("ALL");
  const [selectedTab, setSelectedTab] = useState("zip");
  const [selectedCoverage, setSelectedCoverage] = useState("default");
  const [defaultGeographicCoverage, setDefaultGeographicCoverage] =
    useState(false);
  const [defaultAppointmentTypes, setDefaultAppointmentTypes] = useState(false);
  const [defaultZipCodes, setDefaultZipCodes] = useState(false);
  const [providerDetails, setProviderDetails] = useState(null);
  const [isOverrideSettings, setIsOverrideSettings] = useState(false);
  const [originalDayPreferences, setOriginalDayPreferences] = useState(null);
  const [defaultZones, setDefaultZones] = useState([]);
  const [providerDefaultZones, setProviderDefaultZones] = useState([]);
  const [providerTimezone, setproviderTimezone] = useState(null);
  const [showLeaveForm, setShowLeaveForm] = useState(true);
  const [showHours, setShowHours] = useState(false);
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [open, setOpen] = React.useState(false);
  const [message, setMessage] = useState("Something went wrong");
  const [severity, setSeverity] = React.useState("error");

  const [isLeaveConfModalOpen, setIsLeaveConfModalOpen] = React.useState({ status: false, message: "" });
  const [isDateRangeModalOpen, setIsDateRangeModalOpen] = React.useState({ status: false });
  const leaveFormRef = useRef(null);

  //Weekly Date Range
  const today = moment();
  const [weeklyDateRanges, setWeeklyDateRanges] = useState([]);
  const currentRange = weeklyDateRanges.find((range) => {
    const start = moment(range.start_date);
    const end = moment(range.end_date);
    return today.isBetween(start, end, "day", "[]");
  });
  const [weeklyStartDate, setWeeklyStartDate] = useState(
    currentRange ? currentRange.start_date : moment().format("YYYY-MM-DD")
  );
  const [weeklyEndDate, setWeeklyEndDate] = useState(
    currentRange ? currentRange.end_date : moment().format("YYYY-MM-DD")
  );

  const [isLoadingWeeklyRanges, setIsLoadingWeeklyRanges] = useState(false);

  const [isSaveAsTemplateModalOpen, setIsSaveAsTemplateModalOpen] =
    useState(false);

  const [selectedWeeklyDateRange, setSelectedWeeklyDateRange] = useState(
    currentRange || null
  );
  const [templateName, setTemplateName] = useState(null);
  const [isDeleteRangeModalOpen, setIsDeleteRangeModalOpen] = useState({ status: false, type: null });
  const [selectedTemplateId, setSelectedTemplateId] = useState(null);
  const [isEditMode, setIsEditMode] = useState(false);
  const [isSwitchConfirmationModalOpen, setIsSwitchConfirmationModalOpen] = useState(false);
  const [pendingAction, setPendingAction] = useState(null);
  const [hasUnsavedChanges, setHasUnsavedChanges] = useState(false);
  // Tracks whether the user actually edited "All Days" (ALL) settings in this session.
  // Per-day overrides should only be dropped on save when ALL itself was updated -
  // editing a specific day's tab without touching ALL must still be saved.
  const [allSettingsDirty, setAllSettingsDirty] = useState(false);
  // Tracks which specific weekday tabs the user actually edited this session. A day key
  // can also appear in dayPreferences just because the "copy on visit" inheritance effects
  // (defaultZipCodes/defaultAppointmentTypes/zone_ids merge) populated it when the user
  // merely switched to that tab to look - that alone must not count as an override on save.
  const [dirtyDayKeys, setDirtyDayKeys] = useState(new Set());
  const [timeOffConflictModal, setTimeOffConflictModal] = useState({
    open: false,
    message: "",
    pending: null,
  });


  const shouldDisableFields = () => {
    // Disable fields when:
    // 1. Not in edit mode AND 
    // 2. Not creating a new template (no selected template and template mode is "none")
    return !isEditMode && !(selectedWeeklyDateRange === null && templateMode === "none");
  };

  // Mark template as having unsaved changes when user edits (so switch-confirmation only shows when needed)
  const setDayPreferencesWithDirty = (arg) => {
    setDayPreferences(arg);
    setHasUnsavedChanges(true);
    if (selectedDay === "ALL") {
      setAllSettingsDirty(true);
    } else if (selectedDay) {
      setDirtyDayKeys((prev) => {
        if (prev.has(selectedDay)) return prev;
        const next = new Set(prev);
        next.add(selectedDay);
        return next;
      });
    }
  };
  const setSelectedDaysWithDirty = (arg) => {
    setSelectedDays(arg);
    setHasUnsavedChanges(true);
  };

  // Add these new states for template management
  const [isCreatingNewTemplate, setIsCreatingNewTemplate] = useState(false);
  const [templateMode, setTemplateMode] = useState("none"); // "none", "select", "create"
  const getStatus = (start, end) => {
    if (today.isBetween(start, end, "day", "[]"))
      return { label: "Current", color: "green" };
    if (today.isBefore(start, "day"))
      return { label: "Upcoming", color: "yellow" };
    return { label: "Past", color: "red" };
  };

  const estTimezone = "America/New_York";

  const toggleLeaveForm = () => setShowLeaveForm((prev) => !prev);
  const handleSelectAll = () => {
    setSelectedDays(days);
  };

  const [upsertProviderConstraintAPI] = useUpsertProviderConstraintMutation();
  const [fetchProviderById] = useFetchProviderByIdMutation();
  const [fetchProviderZones] = useFetchProviderZonesMutation();
  const [addWeeklyDateRange] = useAddWeeklyDateRangeMutation();
  const [getWeeklyDateRangeForProvider] = useGetWeeklyDateRangeMutation();
  const [deleteWeeklydateRange] = useDeleteWeeklyDateRangeMutation();
  const [fetchProviderZipCodes] = useFetchProviderZipCodesMutation();
  const [createAvailabilityTemplate] = useCreateAvTemplateMutation();
  const [deleteAssignedRange] = useDeleteAssignmentMutation();

  const user = useSelector(selectUser);

  const [createLog] = useCreateLogsMutation();


  const handleAvailabilityTypeChange = (type) => {
    setAvailabilityType(type);
    setAllSettingsDirty(false);
    setDirtyDayKeys(new Set());
    if (type === "global") {
      // Reset to default settings when switching to global. details.dayPreferences
      // is whatever was last saved for this provider/market and may still carry
      // per-weekday override keys from an earlier "Custom Availability" save -
      // strip everything but ALL so state matches what Global Availability
      // actually means (and what upsertProviderConstraint will now persist).
      setSelectedDays(details.workingDays);
      const resetDayPreferences =
        details.dayPreferences?.ALL != null
          ? { ALL: details.dayPreferences.ALL }
          : details.dayPreferences;
      setDayPreferences(resetDayPreferences);
      setOriginalDayPreferences(resetDayPreferences || {});
    } else {

      const loadedDayPreferences =
        selectedWeeklyDateRange?.day_preferences || weeklyDateRanges[0]?.day_preferences || details?.dayPreferences;
      setDayPreferences(loadedDayPreferences);
      setOriginalDayPreferences(loadedDayPreferences || {});
      setSelectedDays(
        selectedWeeklyDateRange?.working_days || weeklyDateRanges[0]?.working_days || details?.workingDays
      );
      !selectedWeeklyDateRange && setSelectedWeeklyDateRange(weeklyDateRanges[0]);
    }
  };

  const handleEditTemplate = (template) => {
    if (!user?.permissions?.includes('provider_settings.edit_weekly_settings')) {
      return;
    }
    // setEditingTemplateId(template.id);
    setIsEditMode(true);
    setHasUnsavedChanges(false);
    setAllSettingsDirty(false);
    setDirtyDayKeys(new Set());
    setOriginalDayPreferences(template?.day_preferences || {});
    // Load the template data into the form
    handleDateRangeOperation("edit", template, true);
    setSelectedDay("ALL");
    setTimeout(() => {
      if (templateCreationRef.current) {
        templateCreationRef.current.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        });
      }
    }, 100);
  };

  const upsertProviderConstraint = async (
    isCloseModal = true,
    isSaveAsTemplate
  ) => {
    try {
      const payload = {
        activity: `Provider constraints updated for Provider ${details?.name} by User - ${user?.details?.name}`,
        type: ACTIVITY_TYPE.PROVIDER_SETTINGS_UPDATE,
        data: {
          providerId: details.id,
        },
      };
      // Filter day preferences to only include selected days and ensure working hours are complete.
      // Under "Global Availability", per-weekday override keys (MONDAY, TUESDAY, ...) left over
      // from a prior "Custom Availability" save must be dropped once the user actually updates
      // "All Days" again - otherwise they silently keep applying on the backend (which honors a
      // per-day override over ALL whenever one is present). But if the user only edited a specific
      // day's tab in this session without touching ALL, that per-day edit is intentional and must
      // still be saved - so only drop non-ALL keys when ALL was actually modified this session.
      // A day key can exist in dayPreferences purely because the "copy on visit"
      // inheritance effects (defaultZipCodes/defaultAppointmentTypes/zone_ids merge)
      // populated it when the user merely switched to that tab to look - that must not
      // count as an override. Only send a day if it was a real persisted override to
      // begin with, or the user actually edited it this session.
      const isRealDayOverride = (day) =>
        day === "ALL" ||
        dirtyDayKeys.has(day) ||
        Object.prototype.hasOwnProperty.call(originalDayPreferences || {}, day);

      const filteredDayPreferences = Object.keys(dayPreferences).reduce(
        (acc, day) => {
          if (availabilityType === "global" && day !== "ALL" && allSettingsDirty) {
            return acc;
          }
          if (day !== "ALL" && !isRealDayOverride(day)) {
            return acc;
          }
          // Include "ALL" day and any specifically selected days
          if (day === "ALL" || selectedDays.includes(day)) {
            // Ensure working hours are complete for each day
            const dayPref = dayPreferences[day] || {};
            const workingHours = dayPref.working_hours || {};

            acc[day] = {
              ...dayPref,
              working_hours: {
                // start: workingHours.start || "09:00",
                // end: workingHours.end || "17:00",
                start: workingHours.start || dayPreferences["ALL"]?.working_hours?.start || "09:00",
                end: workingHours.end || dayPreferences["ALL"]?.working_hours?.end || "17:00",
              },
              // zip_codes is sent as-is for this day. This block only runs for days that
              // already passed isRealDayOverride (a persisted override, or one the user
              // actually edited this session), so an explicitly empty array here means
              // the user deliberately cleared coverage for this day - it must not be
              // silently replaced with All Days' zip codes.
              zip_codes: dayPref.zip_codes || [],
              ...(day !== "ALL" && (!dayPref.zone_ids || dayPref.zone_ids.length === 0)
                ? { zone_ids: dayPreferences["ALL"]?.zone_ids || [] }
                : {}),
            };
          }
          return acc;
        },
        {}
      );
      for (const day in filteredDayPreferences) {
        const { working_hours } = filteredDayPreferences[day];
        const { start, end } = working_hours;

        const startT = moment(start, "HH:mm");
        const endT = moment(end, "HH:mm");

        if (startT.isAfter(endT)) {
          const formattedDay =
            day.charAt(0).toUpperCase() + day.slice(1).toLowerCase();
          showAlert(
            `Start time cannot be after end time (${formattedDay}${day === "ALL" ? " Days" : ""
            }).`,
            "error"
          );
          return;
        }
      }

      try {
        await upsertProviderConstraintAPI({
          id: details.id,
          data: {
            working_days: selectedDays,
            day_preferences: filteredDayPreferences,
            market_id: selectedMarket
          },

        }).unwrap();

        const updatedProviders = providers.map((provider) => {
          if (provider.id === details.id) {
            // Update specific market constraints
            if (selectedMarket !== "ALL") {
              const updatedMarket = provider.market?.map((market) => {
                // Check both id and market_id since your data uses market_id
                if (market.id === selectedMarket || market.market_id === selectedMarket) {
                  return {
                    ...market,
                    constraints: {
                      working_days: selectedDays,
                      day_preferences: filteredDayPreferences,
                    },
                  };
                }
                return market;
              });

              // Check if this is the primary market
              const isPrimaryMarket = provider.market?.find(m =>
                (m.id === selectedMarket || m.market_id === selectedMarket) &&
                m.is_primary_market
              );

              return {
                ...provider,
                market: updatedMarket,
                // Update root level constraints only if this is the primary market
                ...(isPrimaryMarket ? {
                  workingDays: selectedDays,
                  dayPreferences: filteredDayPreferences,
                } : {}),
              };
            } else {
              // For "ALL" market (update all markets)
              const updatedMarket = provider.market?.map((market) => ({
                ...market,
                constraints: {
                  working_days: selectedDays,
                  day_preferences: filteredDayPreferences,
                },
              }));

              return {
                ...provider,
                market: updatedMarket,
                workingDays: selectedDays,
                dayPreferences: filteredDayPreferences,
              };
            }
          }
          return provider;
        });

        setProviders(updatedProviders);

        setProviders(updatedProviders);

        if (isCloseModal) {
          handleEditClick(null);
        }
        await createLog({
          ...payload,
          status: ACTIVITY_STATUS.SUCCESS,
        }).unwrap();
      } catch (error) {
        console.log(error);
        await createLog({
          ...payload,
          status: ACTIVITY_STATUS.FAILED,
        }).unwrap();
      }
    } catch (error) {
      console.log(error);
    }
  };

  const getProviderById = async () => {
    try {
      const { data } = await fetchProviderById({ id: details.id, marketId: selectedMarket }).unwrap();
      setProviderDetails(data);
      // setDefaultZones(prev => ([...(data?.zones?.filter(zone => !prev?.includes(zone?.id))?.map(zone => zone?.id) || [])]));
      setDefaultZones((prev) => [
        ...new Set([...prev, ...(data?.zones?.map((zone) => zone?.id) || [])]),
      ]);
    } catch (error) {
      console.log(error);
    }
  };

  const getProviderZones = async () => {
    try {
      const { data } = await fetchProviderZones(details.id).unwrap();
      setProviderDefaultZones(data);
      setDefaultZones((prev) => [
        ...new Set([...prev, ...(data?.map((zone) => zone?.id) || [])]),
      ]);
    } catch (error) {
      console.log(error);
    }
  };

  const setDeafultValues = () => {
    setName("");
    setType("");
    setStartDate("");
    setEndDate("");
    setStartTime("");
    setEndTime("");
    setShowHours(false);
    setDescription("")
  };

  const [fetchProviderLeavesAPI] = useFetchProviderLeavesMutation();

  const fetchProviderLeaves = async () => {
    try {
      const { data: response } = await fetchProviderLeavesAPI({
        id: details.id,
      }).unwrap();

      setLeaves(response);
    } catch (error) {
      console.log(error);
    }
  };

  const [createProviderLeaveAPI] = useCreateProviderLeaveMutation();

  const createProviderLeave = async (force) => {
    try {
      setIsSubmitted(true);
      setIsLeaveConfModalOpen({ status: false, message: null })
      if (
        !type ||
        !startDate ||
        !endDate ||
        (showHours && !startTime) ||
        (showHours && !endTime)
      ) {
        setMessage("Please fill in all required fields.");
        setSeverity("error");
        setOpen(true);
        return;
      }

      // Convert dates and times to moment objects
      const start = moment(startDate, "YYYY-MM-DD");
      const end = moment(endDate, "YYYY-MM-DD");

      if (start.isAfter(end)) {
        setMessage("Start date cannot be after end date.");
        setSeverity("error");
        setOpen(true);
        return;
      }

      if (showHours) {
        const startT = moment(startTime, "HH:mm");
        const endT = moment(endTime, "HH:mm");

        if (startT.isAfter(endT)) {
          setMessage("Start time cannot be after end time.");
          setSeverity("error");
          setOpen(true);
          return;
        }
      }

      // Check for overlapping leaves
      const hasOverlap = leaves.some((leave) => {
        const leaveStartDate = moment(leave.startDate).startOf("day");
        const leaveEndDate = moment(leave.endDate).startOf("day");
        const newStartDate = moment(startDate).startOf("day");
        const newEndDate = moment(endDate).startOf("day");

        // Check if date ranges overlap
        // Two date ranges overlap if: start1 <= end2 AND end1 >= start2
        const datesOverlap =
          newStartDate.isSameOrBefore(leaveEndDate) &&
          newEndDate.isSameOrAfter(leaveStartDate);

        if (!datesOverlap) {
          return false;
        }

        // Check if existing leave has specific hours
        const existingLeaveHasHours =
          leave.startTime &&
          leave.startTime.trim() !== "" &&
          leave.endTime &&
          leave.endTime.trim() !== "";

        // If both leaves have specific hours, check time overlap
        if (showHours && existingLeaveHasHours) {
          const newStartTime = moment(startTime, "HH:mm");
          const newEndTime = moment(endTime, "HH:mm");
          const leaveStartTime = moment(leave.startTime, "HH:mm");
          const leaveEndTime = moment(leave.endTime, "HH:mm");

          // Check if time ranges overlap
          const timesOverlap =
            newStartTime.isBefore(leaveEndTime) &&
            newEndTime.isAfter(leaveStartTime);

          return timesOverlap;
        }

        // If either leave is a full-day leave and dates overlap, it's an overlap
        return true;
      });

      if (hasOverlap) {
        setMessage(
          "This leave overlaps with an existing leave. Please choose different dates or times."
        );
        setSeverity("error");
        setOpen(true);
        setIsSubmitted(false);
        return;
      }

      const result = await createProviderLeaveAPI({
        id: details.id,
        data: {
          name: type,
          type,
          start_date: startDate,
          end_date: endDate,
          start_time: showHours
            ? // getEstTimezoneTime(startTime, providerTimezone)
              startTime
            : "",
          end_time: showHours
            ? // getEstTimezoneTime(endTime, providerTimezone)
              endTime
            : "",
          force,
          details: description
        },
      }).unwrap();
      if (result?.data?.alert) {

        // showAlert(result?.data?.alert, "warning");
        setIsLeaveConfModalOpen({
          status: true,
          message: result?.data?.alert
        })
        return;
      }

      await createLog({
        activity: `Time off created for Provider ${details?.name} by User - ${user?.details?.name}`,
        type: ACTIVITY_TYPE.PROVIDER_TIME_OFF_CREATE,
        data: {
          providerId: details.id,
          leaveType: type,
          startDate,
          endDate,
        },
        status: ACTIVITY_STATUS.SUCCESS,
      }).unwrap();

      const updatedProviders = providers.map((provider) => {
        if (provider.id === details.id) {
          return {
            ...provider,
            ptos: provider.ptos + 1,
          };
        }

        return provider;
      });

      setProviders(updatedProviders);

      fetchProviderLeaves();
      setDeafultValues();
      setIsSubmitted(false);
      showAlert("Leave added successfully.", "success");
    } catch (error) {
      await createLog({
        activity: `Failed to create time off for Provider ${details?.name} by User - ${user?.details?.name}`,
        type: ACTIVITY_TYPE.PROVIDER_TIME_OFF_CREATE,
        data: {
          providerId: details.id,
          leaveType: type,
        },
        status: ACTIVITY_STATUS.FAILED,
      }).unwrap();
      console.log(error);
    }
  };

  const [updateProviderLeaveAPI] = useUpdateProviderLeaveMutation();

  const updateProviderLeave = async (id, force) => {
    try {
      setIsSubmitted(true);
      setIsLeaveConfModalOpen({ status: false, message: null })
      if (
        !type ||
        !startDate ||
        !endDate ||
        (showHours && !startTime) ||
        (showHours && !endTime)
      )
        return;

      const result = await updateProviderLeaveAPI({
        id,
        data: {
          name: type,
          type,
          start_date: startDate,
          end_date: endDate,
          start_time: showHours
            ? // getEstTimezoneTime(startTime, providerTimezone)
              startTime
            : "",
          end_time: showHours
            ? // getEstTimezoneTime(endTime, providerTimezone)
              endTime
            : "",
          force,
          providerId: details.id,
          details: description
        },
      }).unwrap();
      if (result?.data?.alert) {

        // showAlert(result?.data?.alert, "warning");
        setIsLeaveConfModalOpen({
          status: true,
          message: result?.data?.alert
        })
        return;
      }

      await createLog({
        activity: `Time off updated for Provider ${details?.name} by User - ${user?.details?.name}`,
        type: ACTIVITY_TYPE.PROVIDER_TIME_OFF_UPDATE,
        data: {
          providerId: details.id,
          leaveId: id,
          leaveType: type,
        },
        status: ACTIVITY_STATUS.SUCCESS,
      }).unwrap();

      fetchProviderLeaves();
      setDeafultValues();
      setPtoToEdit(null);
      setIsSubmitted(false);
      showAlert("Leave updated successfully.", "success");
    } catch (error) {
      await createLog({
        activity: `Failed to update time off for Provider ${details?.name} by User - ${user?.details?.name}`,
        type: ACTIVITY_TYPE.PROVIDER_TIME_OFF_UPDATE,
        data: {
          providerId: details.id,
          leaveId: id,
        },
        status: ACTIVITY_STATUS.FAILED,
      }).unwrap();
      console.log(error);
    }
  };

  const [deleteProviderLeaveAPI] = useRemoveProviderLeaveMutation();

  const deleteProviderLeave = async (id) => {
    try {
      await deleteProviderLeaveAPI({
        id,
      }).unwrap();

      const updatedProviders = providers.map((provider) => {
        if (provider.id === details.id) {
          return {
            ...provider,
            ptos: provider.ptos - 1,
          };
        }

        return provider;
      });

      setProviders(updatedProviders);

      await createLog({
        activity: `Time off deleted for Provider ${details?.name} by User - ${user?.details?.name}`,
        type: ACTIVITY_TYPE.PROVIDER_TIME_OFF_DELETE,
        data: {
          providerId: details.id,
          leaveId: id,
        },
        status: ACTIVITY_STATUS.SUCCESS,
      }).unwrap();

      fetchProviderLeaves();
      showAlert("Leave deleted successfully.", "success");
    } catch (error) {
      await createLog({
        activity: `Failed to delete time off for Provider ${details?.name} by User - ${user?.details?.name}`,
        type: ACTIVITY_TYPE.PROVIDER_TIME_OFF_DELETE,
        data: {
          providerId: details.id,
          leaveId: id,
        },
        status: ACTIVITY_STATUS.FAILED,
      }).unwrap();
      console.log(error);
    }
  };

  const [fetchAppointmentTypes] = useFetchAppointmentTypesMutation();

  const getAppointmentTypes = async () => {
    try {
      const { data: response } = await fetchAppointmentTypes({
        organisationId: user.organisation.id,
        rotation: "all",
        format: "all",
        dispatch: "all",
        screen: "provider_settings",
      }).unwrap();

      setAppointmentTypes(response.appointmentTypes);
    } catch (error) {
      console.log(error);
    }
  };

  const [fetchZones] = useFetchZonesMutation();

  const getZones = async () => {
    try {
      const { data: response } = await fetchZones().unwrap();
      setZones(response);
      setZipCodes([...new Set(response.flatMap((e) => e.zip_codes))]);
    } catch (error) {
      console.log(error);
    }
  };

  const getWeeklyDateRanges = async () => {
    try {
      setIsLoadingWeeklyRanges(true);
      const result = await getWeeklyDateRangeForProvider({
        id: details.id,
        market_id: selectedMarket

      })?.unwrap();
      const ranges = result?.data || [];
      let currentRange = null;

      if (selectedWeeklyDateRange) {
        currentRange = ranges.find(
          (range) => range.id === selectedWeeklyDateRange.id
        );
      }

      // ✅ Otherwise, pick the one where today falls between start and end
      if (!currentRange) {
        currentRange = ranges.find((range) => {
          const start = moment(range.start_date);
          const end = moment(range.end_date);
          return today.isBetween(start, end, "day", "[]");
        });
      }

      setWeeklyDateRanges(result?.data);
      setWeeklyStartDate(
        currentRange?.start_date || moment().format("YYYY-MM-DD")
      );
      setWeeklyEndDate(currentRange?.end_date || moment().format("YYYY-MM-DD"));
      setSelectedWeeklyDateRange(currentRange);

      if (availabilityType == "global") {
        // Reset to default settings when switching to global
        setSelectedDays(details.workingDays);
        setDayPreferences(details.dayPreferences);
        setOriginalDayPreferences(details.dayPreferences || {});
      } else {
        const loadedDayPreferences =
          currentRange?.day_preferences || details.dayPreferences;
        setSelectedDays(currentRange?.working_days || details?.workingDays);
        setDayPreferences(loadedDayPreferences);
        setOriginalDayPreferences(loadedDayPreferences || {});
      }
      setDirtyDayKeys(new Set());
    } catch (err) {
      console.log(err);
    } finally {
      setIsLoadingWeeklyRanges(false);
    }
  };

  const handleEditClickPTO = (pto) => {
    if (ptoToEdit) {
      setPtoToEdit(null);
      setDeafultValues();
    } else {
      setPtoToEdit(pto);
      setName(pto.name);
      setType(pto.type);
      setStartDate(pto.startDate);
      setEndDate(pto.endDate);
      setDescription(pto.details);
      if (pto.startTime && pto.endTime) {
        setShowHours(true);
        setStartTime(pto.startTime);
        setEndTime(pto.endTime);
      } else {
        setShowHours(false);
        setStartTime("");
        setEndTime("");
      }
    }


    // setTimeout(() => {
    //   if (leaveFormRef.current) {
    //     // const container = document.querySelector('.h-[calc(100vh-285px)]');
    //     const container = document.querySelector('[class*="h-\\[calc\\(100vh-285px\\)\\]"]');

    //     if (container) {
    //       const targetOffset = leaveFormRef.current.offsetTop;
    //       const containerOffset = container.offsetTop;
    //       const scrollPosition = targetOffset - containerOffset - 20; // 20px padding

    //       container.scrollTo({
    //         top: scrollPosition,
    //         behavior: 'smooth'
    //       });
    //     }
    //   }
    // }, 100);

  };

  const getProviderTimezoneTime = (time, timezone) => {
    if (time && timezone) {
      const estTime = moment.tz(time, "HH:mm", estTimezone);
      return estTime.clone().tz(timezone).format("HH:mm");
    } else {
      return time;
    }
  };

  const getEstTimezoneTime = (time, timezone) => {
    if (time && timezone) {
      const providedTime = moment.tz(time, "HH:mm", timezone);
      return providedTime.clone().tz(estTimezone).format("HH:mm");
    } else {
      return time;
    }
  };
  const handleClose = () => {
    setOpen(false);
  };
  /** True if two calendar date ranges [aStart,aEnd] and [bStart,bEnd] overlap (inclusive). */
  const dateRangesOverlap = (aStart, aEnd, bStart, bEnd) =>
    aStart.isSameOrBefore(bEnd) && aEnd.isSameOrAfter(bStart);

  /**
   * Warn only when a time-off period overlaps the **assigned** date range (calendar dates),
   * not by weekday pattern inside some other template range.
   */
  const getTimeOffBlockedMessage = () => {
    const rangeStart = weeklyStartDate || selectedWeeklyDateRange?.start_date;
    const rangeEnd = weeklyEndDate || selectedWeeklyDateRange?.end_date;
    if (!rangeStart || !rangeEnd) return null;

    const assignStart = moment(rangeStart).startOf("day");
    const assignEnd = moment(rangeEnd).startOf("day");
    if (!assignStart.isValid() || !assignEnd.isValid() || assignEnd.isBefore(assignStart)) {
      return null;
    }

    const hasOverlappingLeave = (leaves || []).some((leave) => {
      if (!leave?.startDate || !leave?.endDate) return false;
      const leaveStart = moment(leave.startDate).startOf("day");
      const leaveEnd = moment(leave.endDate).startOf("day");
      if (!leaveStart.isValid() || !leaveEnd.isValid()) return false;
      return dateRangesOverlap(assignStart, assignEnd, leaveStart, leaveEnd);
    });

    if (!hasOverlappingLeave) return null;

    return `The provider has time off that overlaps this assigned date range (${assignStart.format(
      "MMM D, YYYY"
    )} – ${assignEnd.format("MMM D, YYYY")}). Kindly review their Time Off before proceeding.`;
  };

  const handleCancelTimeOffConflict = () => {
    setTimeOffConflictModal({ open: false, message: "", pending: null });
  };

  const handleConfirmTimeOffConflict = async () => {
    const pending = timeOffConflictModal.pending;
    setTimeOffConflictModal({ open: false, message: "", pending: null });
    if (pending?.tmpId !== undefined) {
      await handleUpsertDateRange(pending.tmpId, { skipTimeOffCheck: true });
    }
  };

  const handleUpsertDateRange = async (tmpId, options = {}) => {
    try {
      if (!options.skipTimeOffCheck) {
        const blockMsg = getTimeOffBlockedMessage();
        if (blockMsg) {
          setTimeOffConflictModal({
            open: true,
            message: blockMsg,
            pending: { tmpId: tmpId ?? null },
          });
          return;
        }
      }
      setIsSaveAsTemplateModalOpen(false);
      const filteredDayPreferences = Object.keys(dayPreferences).reduce(
        (acc, day) => {
          // Include "ALL" day and any specifically selected days
          if (day === "ALL" || selectedDays.includes(day)) {
            // Ensure working hours are complete for each day
            const dayPref = dayPreferences[day] || {};
            const workingHours = dayPref.working_hours || {};

            acc[day] = {
              ...dayPref,
              working_hours: {
                start: workingHours.start || dayPreferences["ALL"]?.working_hours?.start || "09:00",
                end: workingHours.end || dayPreferences["ALL"]?.working_hours?.end || "17:00",
              },
              // For non-ALL days, inherit zip_codes/zone_ids from ALL when this day has none (matches UI fallback)
              ...(day !== "ALL" && (!dayPref.zip_codes || dayPref.zip_codes.length === 0)
                ? { zip_codes: dayPreferences["ALL"]?.zip_codes || [] }
                : {}),
              ...(day !== "ALL" && (!dayPref.zone_ids || dayPref.zone_ids.length === 0)
                ? { zone_ids: dayPreferences["ALL"]?.zone_ids || [] }
                : {}),
            };
          }
          return acc;
        },
        {}
      );

      for (const day in filteredDayPreferences) {
        const { working_hours } = filteredDayPreferences[day];
        const { start, end } = working_hours;

        const startT = moment(start, "HH:mm");
        const endT = moment(end, "HH:mm");

        if (startT.isAfter(endT)) {
          const formattedDay =
            day.charAt(0).toUpperCase() + day.slice(1).toLowerCase();
          showAlert(
            `Start time cannot be after end time (${formattedDay}${day === "ALL" ? " Days" : ""
            }).`,
            "error"
          );
          return;
        }
      }

      const result = await addWeeklyDateRange({
        id: details.id,
        data: {
          start_date: weeklyStartDate || selectedWeeklyDateRange?.start_date,
          end_date: weeklyEndDate || selectedWeeklyDateRange?.end_date,
          template_id: tmpId || selectedTemplateId || selectedWeeklyDateRange?.id,
          market_id: selectedMarket
        },
      })?.unwrap();

      await createLog({
        activity: `Weekly date range assigned to ${selectedWeeklyDateRange?.template_name} template  for Provider ${details?.name} by User - ${user?.details?.name}`,
        type: ACTIVITY_TYPE.PROVIDER_WEEKLY_RANGE_ASSIGNMENT,
        data: {
          providerId: details.id,
          rangeId: selectedWeeklyDateRange?.id || result?.data?.id,
          startDate: weeklyStartDate,
          endDate: weeklyEndDate,
        },
        status: ACTIVITY_STATUS.SUCCESS,
      }).unwrap();
      getWeeklyDateRanges();
      setTemplateName(null);
      setHasUnsavedChanges(false);
      showAlert(
        selectedWeeklyDateRange?.id
          ? "Weekly availability updated successfully."
          : "Weekly availability added successfully.",
        "success"
      );
    } catch (err) {
      await createLog({
        activity: `Weekly date range assigned to ${selectedWeeklyDateRange?.template_name} template  for Provider ${details?.name} by User - ${user?.details?.name}`,
        type: ACTIVITY_TYPE.PROVIDER_WEEKLY_RANGE_ASSIGNMENT,
        data: {
          providerId: details.id,
          rangeId: selectedWeeklyDateRange?.id,
          startDate: weeklyStartDate,
          endDate: weeklyEndDate,
        },
        status: ACTIVITY_STATUS.FAILED,
      }).unwrap();
      console.log(err);
      showAlert(err?.data?.message, "error");
    }
  };
  const handleUpsertTemplate = async () => {
    if (!user?.permissions?.includes('provider_settings.edit_weekly_settings')) {
      return;
    }
    try {
      setIsSaveAsTemplateModalOpen(false);
      const filteredDayPreferences = Object.keys(dayPreferences).reduce(
        (acc, day) => {
          // Include "ALL" day and any specifically selected days
          if (day === "ALL" || selectedDays.includes(day)) {
            // Ensure working hours are complete for each day
            const dayPref = dayPreferences[day] || {};
            const workingHours = dayPref.working_hours || {};

            acc[day] = {
              ...dayPref,
              working_hours: {

                start: workingHours.start || dayPreferences["ALL"]?.working_hours?.start || "09:00",
                end: workingHours.end || dayPreferences["ALL"]?.working_hours?.end || "17:00",
              },
              // For non-ALL days, inherit zip_codes/zone_ids from ALL when this day has none (matches UI fallback)
              ...(day !== "ALL" && (!dayPref.zip_codes || dayPref.zip_codes.length === 0)
                ? { zip_codes: dayPreferences["ALL"]?.zip_codes || [] }
                : {}),
              ...(day !== "ALL" && (!dayPref.zone_ids || dayPref.zone_ids.length === 0)
                ? { zone_ids: dayPreferences["ALL"]?.zone_ids || [] }
                : {}),
            };
          }
          return acc;
        },
        {}
      );

      for (const day in filteredDayPreferences) {
        const { working_hours } = filteredDayPreferences[day];
        const { start, end } = working_hours;

        const startT = moment(start, "HH:mm");
        const endT = moment(end, "HH:mm");

        if (startT.isAfter(endT)) {
          const formattedDay =
            day.charAt(0).toUpperCase() + day.slice(1).toLowerCase();
          showAlert(
            `Start time cannot be after end time (${formattedDay}${day === "ALL" ? " Days" : ""
            }).`,
            "error"
          );
          return;
        }
      }

      const result = await createAvailabilityTemplate({
        id: details.id,
        data: {
          working_days: selectedDays,
          day_preferences: filteredDayPreferences,
          // start_date: weeklyStartDate || selectedWeeklyDateRange?.start_date,
          // end_date: weeklyEndDate || selectedWeeklyDateRange?.end_date,
          template_name: templateName || null,
          id: selectedWeeklyDateRange?.id || null,
          providerName: details.name,

          market_id: selectedMarket !== "ALL" ? Number(selectedMarket) : null,
        },
      })?.unwrap();

      await createLog({
        activity: `Availability template ${selectedWeeklyDateRange?.id ? 'updated' : 'created'} for Provider ${details?.name} by User - ${user?.details?.name}`,
        type: selectedWeeklyDateRange?.id ? ACTIVITY_TYPE.PROVIDER_AVAILABILITY_TEMPLATE_UPDATE : ACTIVITY_TYPE.PROVIDER_AVAILABILITY_TEMPLATE_CREATE,
        data: {
          providerId: details.id,
          templateId: selectedWeeklyDateRange?.id || result?.data?.id,
          templateName: templateName,
        },
        status: ACTIVITY_STATUS.SUCCESS,
      }).unwrap();
      getWeeklyDateRanges();
      setTemplateName(null);
      setHasUnsavedChanges(false);
      showAlert(
        selectedWeeklyDateRange?.id
          ? "Weekly availability updated successfully."
          : "Weekly availability added successfully.",
        "success"
      );
    } catch (err) {

      await createLog({
        activity: `Failed to ${selectedWeeklyDateRange?.id ? 'update' : 'create'} availability template for Provider ${details?.name} by User - ${user?.details?.name}`,
        type: selectedWeeklyDateRange?.id ? ACTIVITY_TYPE.PROVIDER_AVAILABILITY_TEMPLATE_UPDATE : ACTIVITY_TYPE.PROVIDER_AVAILABILITY_TEMPLATE_CREATE,
        data: {
          providerId: details.id,
        },
        status: ACTIVITY_STATUS.FAILED,
      }).unwrap();
      console.log(err);
      showAlert(err?.data?.message, "error");
    }

  }
  const handleDeleteDateRange = async () => {
    try {
      const result = await deleteWeeklydateRange({
        provider_id: details?.id,
        id: selectedWeeklyDateRange?.id,
      })?.unwrap();

      await createLog({
        activity: `Availability template ${selectedWeeklyDateRange?.template_name} deleted for Provider ${details?.name} by User - ${user?.details?.name}`,
        type: ACTIVITY_TYPE.PROVIDER_AVAILABILITY_TEMPLATE_UPDATE,
        data: {
          providerId: details.id,
          rangeId: selectedWeeklyDateRange?.id,
          rangeName: selectedWeeklyDateRange?.template_name,
        },
        status: ACTIVITY_STATUS.SUCCESS,
      }).unwrap();
      showAlert("Custom availability deleted successfully", "success");
      getWeeklyDateRanges();
      setIsDeleteRangeModalOpen({ status: false, type: null });
    } catch (err) {
      await createLog({
        activity: `Availability template ${selectedWeeklyDateRange?.template_name} deleted for Provider ${details?.name} by User - ${user?.details?.name}`,
        type: ACTIVITY_TYPE.PROVIDER_AVAILABILITY_TEMPLATE_UPDATE,
        data: {
          providerId: details.id,
          rangeId: selectedWeeklyDateRange?.id,
          rangeName: selectedWeeklyDateRange?.template_name,
        },
        status: ACTIVITY_STATUS.FAILED,
      }).unwrap();
      showAlert(err?.data?.message);
      setIsDeleteRangeModalOpen({ status: false, type: null });
    }
  };

  const handleDateRangeOperation = async (operation, rangeData = null, isEdit) => {
    try {
      if (operation === "add") {
        setWeeklyStartDate(moment().format("YYYY-MM-DD"));
        setWeeklyEndDate(moment().add(1, "week").format("YYYY-MM-DD"));

      } else if (operation === "edit") {
        setWeeklyStartDate(rangeData.start_date);
        setWeeklyEndDate(rangeData.end_date);
        setSelectedWeeklyDateRange(rangeData);
        setDayPreferences(rangeData?.day_preferences ?? details?.dayPreferences);
        setSelectedDays(rangeData.working_days);
        setSelectedTemplateId(rangeData?.id);
        setHasUnsavedChanges(false);
      }
      !isEdit && setIsEditMode(false);
    } catch (error) {
      console.error("Date range operation failed:", error);
    }
  };
  const handleRemoveAssignment = async (assignedId, tempId) => {
    try {
      const result = await deleteAssignedRange({
        provider_id: details?.id,
        id: assignedId,
      })?.unwrap();

      await createLog({
        activity: `Date range assignment removed for Provider ${details?.name} by User - ${user?.details?.name}`,
        type: ACTIVITY_TYPE.PROVIDER_ASSIGNMENT_DELETE,
        data: {
          providerId: details.id,
          assignmentId: assignedId,
          templateId: tempId,
        },
        status: ACTIVITY_STATUS.SUCCESS,
      }).unwrap();
      showAlert("Assigned Date Range deleted successfully", "success");
      getWeeklyDateRanges();
      setIsDeleteRangeModalOpen({ status: false, type: null });
    } catch (err) {
      await createLog({
        activity: `Failed to remove date range assignment for Provider ${details?.name} by User - ${user?.details?.name}`,
        type: ACTIVITY_TYPE.PROVIDER_ASSIGNMENT_DELETE,
        data: {
          providerId: details.id,
          assignmentId: assignedId,
        },
        status: ACTIVITY_STATUS.FAILED,
      }).unwrap();
      showAlert(err?.data?.message);
      setIsDeleteRangeModalOpen({ status: false, type: null });
    }

  }
  const handleAddDateRange = () => {
    if (!weeklyStartDate || !weeklyEndDate) return;
    if (moment(weeklyEndDate).isBefore(moment(weeklyStartDate))) {
      showAlert("End date cannot be before start date");
      return;
    }
    // Handle your API or logic here
    handleUpsertDateRange(isDateRangeModalOpen?.templateId);

    // Close modal
    setIsDateRangeModalOpen({ status: null, templateId: null });
  };

  const splitRangeByDeletedDates = (startDate, endDate, deletedDates) => {
    if (!deletedDates || deletedDates.length === 0) {
      return [{ start: startDate, end: endDate }];
    }

    const sortedDeletedDates = [...deletedDates].sort();
    const ranges = [];
    let currentStart = moment(startDate);

    sortedDeletedDates.forEach(deletedDate => {
      const deletedMoment = moment(deletedDate);

      // If there's a gap between currentStart and the deleted date, add a range
      if (currentStart.isBefore(deletedMoment)) {
        ranges.push({
          start: currentStart.format('YYYY-MM-DD'),
          end: deletedMoment.clone().subtract(1, 'day').format('YYYY-MM-DD')
        });
      }

      // Move currentStart to the day after the deleted date
      currentStart = deletedMoment.clone().add(1, 'day');
    });

    // Add the final range if there are days left after the last deleted date
    const endMoment = moment(endDate);
    if (currentStart.isSameOrBefore(endMoment)) {
      ranges.push({
        start: currentStart.format('YYYY-MM-DD'),
        end: endDate
      });
    }

    return ranges;
  };





  useEffect(() => {
    try {
      const providerTimezone = tzlookup(
        details?.location?.lat,
        details?.location?.lng
      );
      setproviderTimezone(providerTimezone);
    } catch (err) {
      setproviderTimezone(estTimezone);
      console.error(err);
    }
    fetchProviderLeaves();
    // getZones();
    // getProviderZones();
    getProviderById();
    getWeeklyDateRanges();
  }, []);

  useEffect(() => {
    getAppointmentTypes();
  }, [user]);

  useEffect(() => {
    if (selectedDay !== "ALL") {
      setDefaultGeographicCoverage(
        !dayPreferences?.[selectedDay]?.zone_ids?.length &&
        !dayPreferences?.[selectedDay]?.zip_codes?.length
      );
    }

    if (selectedDay) {
      const dayZoneIds = dayPreferences?.[selectedDay]?.zone_ids;

      const areSameZones =
        !dayPreferences?.[selectedDay]?.zip_codes?.length &&
        Array.isArray(dayZoneIds) &&
        Array.isArray(defaultZones) &&
        dayZoneIds.length === defaultZones.length &&
        dayZoneIds.every((zone) => defaultZones.includes(zone)) &&
        defaultZones.every((zone) => dayZoneIds.includes(zone));

      setDayPreferences((prev) => {
        return {
          ...prev,
          [selectedDay]: {
            ...(prev?.[selectedDay] || {}),
            zone_ids: [
              ...new Set([
                ...(defaultZones || []),
                ...(prev?.[selectedDay]?.zone_ids || []),
              ]),
            ],
          },
        };
      });

      if (!dayZoneIds && !dayPreferences?.[selectedDay]?.zip_codes?.length) {
        setSelectedCoverage("default");
      } else if (areSameZones) {
        setSelectedCoverage("default");
      } else {
        setSelectedCoverage("custom");
      }

      if (selectedDay !== "ALL") {
        if (!dayPreferences?.[selectedDay]) {
          if (defaultAppointmentTypes) {
            setDefaultAppointmentTypes(false);
          }
          setTimeout(() => {
            setDefaultAppointmentTypes(true);
          }, 500);
        } else {
          const defaultAppointmentTypeIds =
            dayPreferences?.["ALL"]?.appointment_type_ids || [];

          const areSameAppointmentTypes =
            Array.isArray(
              dayPreferences?.[selectedDay]?.appointment_type_ids
            ) &&
            Array.isArray(defaultAppointmentTypeIds) &&
            dayPreferences?.[selectedDay]?.appointment_type_ids?.length ===
            defaultAppointmentTypeIds?.length &&
            dayPreferences?.[selectedDay]?.appointment_type_ids?.every((type) =>
              defaultAppointmentTypeIds?.includes(type)
            ) &&
            defaultAppointmentTypeIds?.every((type) =>
              dayPreferences?.[selectedDay]?.appointment_type_ids?.includes(
                type
              )
            );

          if (areSameAppointmentTypes) {
            setDefaultAppointmentTypes(true);
          } else {
            setDefaultAppointmentTypes(false);
          }
        }

        // Same "copy on visit" pattern as appointment types above, but keyed off
        // the zip_codes key specifically (not the whole day object), since other
        // effects such as the zone_ids merge above can create dayPreferences[selectedDay]
        // before the user has configured zip codes for that day.
        if (
          !Object.prototype.hasOwnProperty.call(
            dayPreferences?.[selectedDay] || {},
            "zip_codes"
          )
        ) {
          if (defaultZipCodes) {
            setDefaultZipCodes(false);
          }
          setTimeout(() => {
            setDefaultZipCodes(true);
          }, 500);
        } else {
          const defaultZipCodeValues = dayPreferences?.["ALL"]?.zip_codes || [];

          const areSameZipCodes =
            Array.isArray(dayPreferences?.[selectedDay]?.zip_codes) &&
            Array.isArray(defaultZipCodeValues) &&
            dayPreferences?.[selectedDay]?.zip_codes?.length ===
            defaultZipCodeValues?.length &&
            dayPreferences?.[selectedDay]?.zip_codes?.every((zip) =>
              defaultZipCodeValues?.includes(zip)
            ) &&
            defaultZipCodeValues?.every((zip) =>
              dayPreferences?.[selectedDay]?.zip_codes?.includes(zip)
            );

          if (areSameZipCodes) {
            setDefaultZipCodes(true);
          } else {
            setDefaultZipCodes(false);
          }
        }
      }
    }
  }, [selectedDay, providerDefaultZones]);

  useEffect(() => {
    if (selectedDay !== "ALL" && defaultAppointmentTypes) {
      setDayPreferences((prev) => {
        return {
          ...prev,
          [selectedDay]: {
            ...prev?.[selectedDay],
            appointment_type_ids:
              dayPreferences?.["ALL"]?.appointment_type_ids || [],
            // appointment_type_ids: Array.from(
            //   new Set([
            //     ...(prev?.[selectedDay]?.appointment_type_ids || []),
            //     ...(prev?.["ALL"]?.appointment_type_ids || [])
            //   ])
            // )
          },
        };
      });
    }
  }, [defaultAppointmentTypes]);

  useEffect(() => {
    if (selectedDay !== "ALL" && defaultZipCodes) {
      setDayPreferences((prev) => {
        return {
          ...prev,
          [selectedDay]: {
            ...prev?.[selectedDay],
            zip_codes: dayPreferences?.["ALL"]?.zip_codes || [],
          },
        };
      });
    }
  }, [defaultZipCodes]);


  useEffect(() => {
    // Handle template selection when market changes (only in custom mode)
    const constraints = getMarketConstraints(selectedMarket);
    if (availabilityType === "custom") {
      let templatesForCurrentMarket = weeklyDateRanges;

      // Filter templates for selected market (if not "ALL")
      if (selectedMarket !== "ALL") {
        templatesForCurrentMarket = weeklyDateRanges.filter(template =>
          template.provider_market_id === Number(selectedMarket)
        );
      }

      // Check if currently selected template belongs to the new market
      if (selectedWeeklyDateRange) {
        const isTemplateForCurrentMarket = selectedMarket === "ALL" ||
          selectedWeeklyDateRange.provider_market_id === Number(selectedMarket);
        if (!isTemplateForCurrentMarket) {
          // Selected template doesn't belong to new market
          if (templatesForCurrentMarket.length > 0) {
            // Select first template for the new market
            const firstTemplate = templatesForCurrentMarket[0];
            setSelectedWeeklyDateRange(firstTemplate);
            setDayPreferences(firstTemplate?.day_preferences || constraints.dayPreferences);
            setSelectedDays(firstTemplate?.working_days || constraints.workingDays);
          } else {
            // No templates for this market - clear selection
            setSelectedWeeklyDateRange(null);
            setDayPreferences(constraints.dayPreferences);
            setSelectedDays(constraints.workingDays);
          }
        }
      } else {
        // No template selected - select first one if available
        if (templatesForCurrentMarket.length > 0) {
          const firstTemplate = templatesForCurrentMarket[0];
          setSelectedWeeklyDateRange(firstTemplate);
          setDayPreferences(firstTemplate?.day_preferences || constraints.dayPreferences || details?.dayPreferences);
          setSelectedDays(firstTemplate?.working_days || constraints.workingDays || details?.workingDays);
        } else {
          // No templates - ensure we reset to market's global constraints
          setSelectedWeeklyDateRange(null);
          setTemplateMode("none");
          setIsEditMode(false);
          setDayPreferences(constraints.dayPreferences);
          setSelectedDays(constraints.workingDays);
        }
      }
    } else {
      setDayPreferences(constraints.dayPreferences);
      setSelectedDays(constraints.workingDays);
    }
  }, [selectedMarket, availabilityType, weeklyDateRanges]);

  // useEffect(() => {
  //   if (availabilityType === "custom") {
  //     // If switching to custom mode with no template selected, reset to empty
  //     if (!selectedTemplateId && !selectedWeeklyDateRange) {
  //       setTemplateMode("none");
  //       resetToEmptyState();
  //     }
  //   }
  // }, [availabilityType, selectedTemplateId, selectedWeeklyDateRange]);

  const getMarketConstraints = (marketId) => {
    if (marketId === "ALL") {
      return {
        workingDays: details.workingDays || ["MONDAY", "TUESDAY", "WEDNESDAY", "THURSDAY", "FRIDAY"],
        dayPreferences: details.dayPreferences || {
          ALL: {
            visits_count: 15,
            working_hours: { start: "09:00", end: "17:00" },
            appointment_type_ids: [],
            zone_ids: [],
            zip_codes: [],
            deleted_dates: [],
          },
        }
      };
    }

    // Find the specific market from details.market array
    const market = details.market?.find(m => m.id === marketId);
    if (market?.constraints) {
      const defaultDayPrefs = details.dayPreferences
      return {
        workingDays:
          market.constraints.working_days || details.workingDays,
        dayPreferences:
          market.constraints.day_preferences ?? defaultDayPrefs,
      };
    }

    // Fallback to global constraints
    return {
      workingDays: details.workingDays || ["MONDAY", "TUESDAY", "WEDNESDAY", "THURSDAY", "FRIDAY"],
      dayPreferences: details.dayPreferences || {
        ALL: {
          visits_count: 15,
          working_hours: { start: "09:00", end: "17:00" },
          appointment_type_ids: [],
          zone_ids: [],
          zip_codes: [],
          deleted_dates: [],
        },
      }
    };
  };



  // Reset to empty state
  const resetToEmptyState = () => {
    setSelectedDays([]);
    setDayPreferences({});
    setWeeklyStartDate(moment().format("YYYY-MM-DD"));
    setWeeklyEndDate(moment().add(1, 'week').format("YYYY-MM-DD"));
  };
  const templateCreationRef = useRef(null);
  // Handle template deselection
  const handleDeselectTemplate = (action, template = null, force) => {
    // Check permission when adding new template
    if (action === 'add' && !user?.permissions?.includes('provider_settings.edit_weekly_settings')) {
      return;
    }
    // Only show confirmation when there are actual unsaved changes
    if (isEditMode && hasUnsavedChanges && !force) {
      setPendingAction({ type: action, template });
      setIsSwitchConfirmationModalOpen(true);
      return;
    }

    setHasUnsavedChanges(false);
    setSelectedTemplateId(null);
    setSelectedWeeklyDateRange(null);
    setTemplateMode("none");
    resetToEmptyState();
    setIsEditMode(false);


    setTimeout(() => {
      if (templateCreationRef.current) {
        templateCreationRef.current.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        });
      }
    }, 100);


  };

  const handleConfirmSwitch = () => {
    if (pendingAction) {
      handleDeselectTemplate(null, null, true)
    }
    setIsSwitchConfirmationModalOpen(false);
    setPendingAction(null);
  };

  const handleCancelSwitch = () => {
    setIsSwitchConfirmationModalOpen(false);
    setPendingAction(null);
  };
  return (
    <ReusableModal
      open
      title={"Settings | " + details.name}
      onClose={() => handleEditClick(null)}
    >

      {timeOffConflictModal.open && (
        <div style={modalOverlayStyle}>
          <div style={modalStyle}>
            <div className="px-2 py-2 bg-white rounded-t d-flex justify-content-between align-items-center">
              <span className="gap-2 font-bold text-gray-800 text-md d-flex align-items-center">
                <WarningRoundedIcon className="text-amber-500" fontSize="small" />
                Time off overlap
              </span>
              <Tooltip title="Close">
                <button type="button" onClick={handleCancelTimeOffConflict}>
                  <CloseIcon />
                </button>
              </Tooltip>
            </div>
            <div className="p-1">
              <p className="mb-2 text-sm text-gray-700">{timeOffConflictModal.message}</p>
              <p className="mb-3 text-sm font-medium text-gray-700">
                Do you still want to assign this date range to the template?
              </p>
              <div className="flex gap-2 justify-end">
                <button
                  type="button"
                  className="px-4 py-2 text-sm font-medium text-gray-700 bg-white rounded-md border border-gray-300 hover:bg-gray-50"
                  onClick={handleCancelTimeOffConflict}
                >
                  Cancel
                </button>
                <button
                  type="button"
                  className="px-4 py-2 text-sm font-medium text-white bg-blue-600 rounded-md hover:bg-blue-700"
                  onClick={handleConfirmTimeOffConflict}
                >
                  Assign anyway
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {isSwitchConfirmationModalOpen && (
        <div style={modalOverlayStyle}>
          <div style={modalStyle}>
            <div className="px-2 py-2 bg-white rounded-t d-flex justify-content-between align-items-center">
              <span className="font-bold text-gray-800 text-md">
                Unsaved Changes
              </span>
              <Tooltip title="Close">
                <button onClick={handleCancelSwitch}>
                  <CloseIcon />
                </button>
              </Tooltip>
            </div>
            <div className="p-1">
              <div className="flex gap-3 items-start mb-2">
                <span>
                  <p className="text-sm text-gray-700">
                    You are currently editing the template "<span className="font-semibold">{selectedWeeklyDateRange?.template_name}</span>".
                    Switching to create a new template will exit the current editing mode.
                  </p>
                  <p className="mt-2 text-sm font-medium text-gray-700">
                    Would you like to continue and create a new template?
                  </p>
                </span>
              </div>

              <div className="flex gap-2 justify-end">
                <button
                  className="px-4 py-2 text-sm font-medium text-gray-700 bg-white rounded-md border border-gray-300 hover:bg-gray-50"
                  onClick={handleCancelSwitch}
                >
                  Cancel
                </button>
                <button
                  className="px-4 py-2 text-sm font-medium text-white bg-blue-600 rounded-md hover:bg-blue-700"
                  onClick={handleConfirmSwitch}
                >
                  Discard Changes & Continue
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {isSaveAsTemplateModalOpen && (
        <div style={modalOverlayStyle}>
          <div style={modalStyle}>
            <div className="px-2 py-2 bg-white rounded-t d-flex justify-content-between align-items-center">
              <span className="font-bold text-gray-800 text-md">
                Save Template
              </span>
              <Tooltip title="Close">
                <button
                  onClick={() => {
                    setIsSaveAsTemplateModalOpen(false);
                    setTemplateName(null);
                  }}
                >
                  <CloseIcon />
                </button>
              </Tooltip>
            </div>
            <span
              className="flex-col d-flex"
              style={{ padding: "10px 10px 0px 10px ", minWidth: "40vw" }}
            >
              {isEditMode && (
                <div className="p-3 mb-4 bg-gray-50 rounded-md border border-gray-200">
                  <div className="flex gap-3 items-start">
                    <div className="flex-1">
                      <p className="mt-1 text-sm text-gray-700">
                        You have modified the existing template. This will affect current and future availabilities assigned to this template. Would you like to confirm the changes?
                      </p>
                    </div>
                  </div>
                </div>
              )}
              <div className="flex flex-col gap-1 mb-2">
                <label className="text-sm font-medium text-gray-700">
                  Template Name
                </label>
                <input
                  type="text"
                  value={templateName}
                  onChange={(e) => setTemplateName(e.target.value)}
                  placeholder="e.g. Morning Shift, Default Pattern"
                  className="px-3 py-2 text-sm rounded-md border border-gray-300 focus:outline-none focus:ring-1 focus:ring-blue-500"
                />
              </div>

              <div className="gap-1 justify-end d-flex">
                <button
                  className="px-3 py-2 text-sm font-semibold text-white rounded-md bg-primaryblue"
                  onClick={() => {
                    // handleUpsertDateRange()
                    handleUpsertTemplate()
                  }}
                >
                  Save
                </button>
              </div>
            </span>
          </div>
        </div >
      )}
      {isDeleteRangeModalOpen?.status && (
        <div style={modalOverlayStyle}>
          <div style={modalStyle}>
            <div className="px-2 py-2 bg-white rounded-t d-flex justify-content-between align-items-center">
              <span className="font-bold text-gray-800 text-md">
                {isDeleteRangeModalOpen?.type == 'range' ? 'Delete Assigned Date Range' : 'Delete Custom Availability'}
              </span>
              <Tooltip title="Close">
                <button
                  onClick={() => {
                    setIsDeleteRangeModalOpen({ status: false, type: null });
                  }}
                >
                  <CloseIcon />
                </button>
              </Tooltip>
            </div>
            <span
              className="flex-col d-flex"
              style={{ padding: "10px 10px 0px 10px ", minWidth: "40vw" }}
            >
              <div className="m-0">
                <p>Are you sure you want to delete {isDeleteRangeModalOpen?.type == 'range' ? 'date range' : <span className="font-semibold text-primaryblue">"{selectedWeeklyDateRange?.template_name}"</span>}?</p>
              </div>

              <div className="gap-1 justify-end d-flex">
                <button
                  className="px-3 py-2 text-sm font-semibold text-white rounded-md bg-primaryblue"
                  onClick={() => {
                    isDeleteRangeModalOpen?.type == 'range' ? handleRemoveAssignment(isDeleteRangeModalOpen?.rangeId) : handleDeleteDateRange()
                  }}
                >
                  Delete
                </button>
              </div>
            </span>
          </div>
        </div>
      )}
      {isLeaveConfModalOpen?.status && (
        <div style={modalOverlayStyle}>
          <ReusableModal
            open={isLeaveConfModalOpen?.status}
            title={"Absence Warning"}
            onClose={() => setIsLeaveConfModalOpen({ status: null, message: null })}
          >
            <div style={modalStyle}>

              <span
                className="flex-col d-flex"
                style={{ padding: "10px 10px 0px 10px ", minWidth: "40vw" }}
              >
                <div className="flex flex-col gap-1 mb-2">
                  {`${isLeaveConfModalOpen?.message}Would you like to proceed?`}
                </div>

                <div className="gap-2 justify-end d-flex">
                  <button
                    className="px-3 py-2 text-sm font-semibold text-white rounded-md bg-primaryblue"
                    onClick={() => {
                      setIsLeaveConfModalOpen({ status: null, message: null });
                    }}
                  >
                    Cancel
                  </button>
                  <button
                    className="px-3 py-2 text-sm font-semibold text-white rounded-md bg-primaryblue"
                    onClick={() =>
                      ptoToEdit ? updateProviderLeave(ptoToEdit?.id, true) : createProviderLeave(true)
                    }
                  >
                    {ptoToEdit ? 'Update' : 'Add'}
                  </button>
                </div>
              </span>
            </div>
          </ReusableModal>
        </div>
      )}
      {isDateRangeModalOpen?.status && (
        <div style={modalOverlayStyle}>
          <ReusableModal
            open={isDateRangeModalOpen?.status}
            title={"Assign Date Range"}
            onClose={() => setIsDateRangeModalOpen({ status: null, data: null, isEditing: false })}
          >
            <div style={modalStyle}>
              <div
                className="flex flex-col p-4"
                style={{ minWidth: "40vw" }}
              >
                {/* Date Inputs */}
                <div className="flex flex-row gap-6">
                  {/* Start Date */}
                  <div className="flex flex-col flex-1">
                    <label className="mb-1 text-sm font-medium text-gray-600">
                      Start Date
                    </label>
                    <input
                      type="date"
                      value={weeklyStartDate}
                      min={moment().format("YYYY-MM-DD")} // Prevent past dates
                      onChange={(e) => {
                        setHasUnsavedChanges(true);
                        setWeeklyStartDate(e.target.value);
                        // setSelectedWeeklyDateRange(null);
                        // setSelectedTemplateId(null);
                        if (
                          moment(e.target.value).isAfter(moment(weeklyEndDate)) &&
                          weeklyEndDate !== null
                        ) {
                          setWeeklyEndDate(e.target.value);
                        }
                      }}
                      className="px-3 py-2 text-sm bg-white rounded-md border border-gray-300 focus:outline-none focus:ring-2 focus:ring-primaryblue"
                    />
                  </div>

                  {/* End Date */}
                  <div className="flex flex-col flex-1">
                    <label className="mb-1 text-sm font-medium text-gray-600">
                      End Date
                    </label>
                    <input
                      type="date"
                      value={weeklyEndDate}
                      min={weeklyStartDate || moment().format("YYYY-MM-DD")} // Can't be before start date
                      onChange={(e) => {
                        setHasUnsavedChanges(true);
                        setWeeklyEndDate(e.target.value);
                        // setSelectedWeeklyDateRange(null);
                        // setSelectedTemplateId(null);
                      }}
                      className="px-3 py-2 text-sm bg-white rounded-md border border-gray-300 focus:outline-none focus:ring-2 focus:ring-primaryblue"
                    />
                  </div>
                  {isDateRangeModalOpen?.isEditing == true &&
                    <div className="flex flex-col">
                      <label className="mb-1 text-sm font-medium text-gray-600">
                        Template
                      </label>
                      <select
                        // value={}
                        value={
                          selectedWeeklyDateRange
                            ? selectedWeeklyDateRange.template_name !== null
                              ? selectedWeeklyDateRange.id
                              : "-1"
                            : selectedTemplateId !== null
                              ? selectedTemplateId
                              : "-1"
                        }
                        className={`px-3 py-2 max-w-full text-sm truncate bg-white rounded-md border border-gray-300 cursor-pointer`}

                        placeholder="Select Template"

                        onChange={(e) => {
                          const templateId = Number(e.target.value);
                          setSelectedTemplateId(
                            templateId === -1 ? null : templateId
                          );

                          // When template is selected, clear the selected date range
                          if (templateId !== -1) {
                            // setSelectedDateRangeId(null);

                            setSelectedWeeklyDateRange(null);

                            // Clone template settings
                            const selectedTemplate = weeklyDateRanges.find(
                              (t) => t.id === templateId
                            );
                            if (selectedTemplate) {
                              setSelectedDays(
                                selectedTemplate.working_days || []
                              );
                              setDayPreferences(
                                selectedTemplate.day_preferences || {}
                              );
                            }
                          }
                        }}
                      // disabled={!!selectedWeeklyDateRange}
                      >
                        {weeklyDateRanges?.length > 0 && (
                          <option value="-1" disabled>
                            Select Template
                          </option>
                        )}
                        {weeklyDateRanges?.filter(
                          (pattern) => pattern.template_name !== null
                        ).length > 0 ? (
                          weeklyDateRanges
                            .filter(
                              (pattern) => pattern.template_name !== null
                            )
                            .map((pattern) => (
                              <option
                                key={pattern.id}
                                value={pattern.id}
                                title={pattern.template_name} // tooltip for each option
                              >
                                {pattern.template_name.length > 30
                                  ? `${pattern.template_name.slice(0, 30)}...`
                                  : pattern.template_name}
                              </option>
                            ))
                        ) : (
                          // Show disabled option if no template exists
                          <option value="-1" disabled selected>
                            No templates available
                          </option>
                        )}
                      </select>
                    </div>}
                </div>

                {/* Buttons */}
                <div className="flex gap-3 justify-end pt-3">

                  <button
                    className="px-4 py-2 text-sm font-semibold text-white rounded-md transition-colors bg-primaryblue hover:bg-blue-700"
                    onClick={() => handleAddDateRange()}
                    disabled={!weeklyStartDate || !weeklyEndDate}
                  >
                    {isDateRangeModalOpen?.isEditing ? 'Update Range' : 'Add Range'}
                  </button>
                </div>
              </div>
            </div>

          </ReusableModal>
        </div>
      )
      }
      {screen !== "Provider" && (
        <>
          <div className="flex flex-col gap-4 justify-between items-start p-4 max-w-[900px] ">
            <h1 className="m-0 text-lg font-bold">Scheduling Horizon</h1>
            <div className="flex flex-row gap-6 items-center">
              <div className="flex flex-col gap-2">
                <label className="font-semibold">Start Date</label>
                <input
                  type="date"
                  className="p-2 text-sm text-gray-900 bg-white rounded-lg border border-gray-300 w-fit focus:ring-blue-500 focus:border-blue-500 disabled:opacity-40"
                  min={moment().format("YYYY-MM-DD")}
                  value={from}
                  onChange={(e) => setFrom(e.target.value)}
                />
              </div>
              <div className="flex flex-col gap-2">
                <label className="font-semibold">End Date</label>
                <input
                  type="date"
                  className="p-2 text-sm text-gray-900 bg-white rounded-lg border border-gray-300 w-fit focus:ring-blue-500 focus:border-blue-500 disabled:opacity-40"
                  min={from}
                  value={to}
                  onChange={(e) => setTo(e.target.value)}
                />
              </div>
            </div>
          </div>
          <div className="w-full border border-primarygrayborder" />
        </>
      )
      }
      {
        screen === "Provider" && (
          <>
            <div className="flex bg-gray-50 border-b">
              {/* {user?.permissions?.includes('provider_settings.view_weekly_settings') */}
              {user?.permissions?.includes(
                "provider_settings.view_weekly_settings"
              ) && (
                  <button
                    onClick={() => {
                      setActiveTab(0)
                      setSelectedMarket(details.market[0]?.id)
                    }}
                    className={`
            px-4 py-3 font-medium text-sm transition  relative
            ${activeTab === 0
                        ? "text-blue-600 border-b-3 border-blue-600 bg-white"
                        : "text-gray-500 hover:text-gray-700"
                      }
          `}
                  >
                    Weekly Settings
                    {activeTab === 0 && (
                      <span className="absolute bottom-0 left-0 w-full h-0.5 bg-blue-600"></span>
                    )}
                  </button>
                )}
              {user?.permissions?.includes(
                "provider_settings.view_calendar_view_settings"
              ) && (
                  <button
                    onClick={() => {
                      handleAvailabilityTypeChange("global");
                      setActiveTab(1)
                      setSelectedMarket(details.market[0]?.id)
                    }}
                    className={`
            px-4 py-3 font-medium text-sm transition  relative
            ${activeTab === 1
                        ? "text-blue-600 border-b-3 border-blue-600 bg-white"
                        : "text-gray-500 hover:text-gray-700"
                      }
          `}
                  >
                    Calendar View
                    {activeTab === 1 && (
                      <span className="absolute bottom-0 left-0 w-full h-0.5 bg-blue-600"></span>
                    )}
                  </button>
                )}
              {user?.permissions?.includes("provider_settings.view_time_off") && (
                <button
                  onClick={() => {
                    setActiveTab(2)
                    setSelectedMarket("ALL")
                  }}
                  className={`
            px-4 py-3 font-medium text-sm transition  relative
            ${activeTab === 2
                      ? "text-blue-600 border-b-3 border-blue-600 bg-white"
                      : "text-gray-500 hover:text-gray-700"
                    }
          `}
                >
                  Time Off
                  {activeTab === 2 && (
                    <span className="absolute bottom-0 left-0 w-full h-0.5 bg-blue-600"></span>
                  )}
                </button>
              )}
            </div>
            {details?.market?.length > 1 &&
              <button
                onClick={() => setSelectedMarket("ALL")}
                disabled={activeTab === 0}
                //           className={`
                //   px-4 py-3 font-medium text-sm transition relative
                //   ${selectedMarket === "ALL"
                //               ? "text-blue-600 border-b-3 border-blue-600 bg-white"
                //               : "text-gray-500 hover:text-gray-700"}
                // `}
                className={`
    px-4 py-3 font-medium text-sm transition relative
    ${selectedMarket === "ALL"
                    ? "text-blue-600 border-b-3 border-blue-600 bg-white"
                    : "text-gray-500 hover:text-gray-700"}
    ${activeTab === 0 ? "opacity-50 cursor-not-allowed" : ""} // Add this for visual feedback
  `}
              >
                All Markets
                {selectedMarket === "ALL" && (
                  <span className="absolute bottom-0 left-0 w-full h-0.5 bg-blue-600"></span>
                )}
              </button>}

            {/* Market-specific tabs */}
            {details?.market?.length >= 1 && (
              (details.market.length > 1 || activeTab !== 2) && (
                details.market.map((m) => (
                  <button
                    key={m.id}
                    onClick={() => setSelectedMarket(m.id)}
                    disabled={activeTab === 2}
                    className={`
                      px-4 py-3 font-medium text-sm transition relative disabled:cursor-not-allowed disabled:opacity-50 cursor-pointer
                      ${selectedMarket === m.id
                        ? "text-blue-600 border-b-3 border-blue-600 bg-white"
                        : "text-gray-500 enabled:hover:text-gray-700"}
                    `}
                  >
                    {m.market_name}
                    {m.is_primary_market && " (Primary)"}
                    {selectedMarket === m.id && (
                      <span className="absolute bottom-0 left-0 w-full h-0.5 bg-blue-600"></span>
                    )}
                  </button>
                ))
              )
            )}
            <div className="h-[calc(100vh-321px)] px-[24px] pb-[24px] pt-[10px] overflow-auto w-[66vw] no-scrollbar">
              {activeTab === 0 && (
                <>
                  {activeTab === 0 && ((!details.location?.lat && !details.location?.lng) || (details?.qualification == null)) ? (
                    <button
                      className="flex gap-1 justify-center items-center self-center mb-2 w-full text-yellow-600 rounded-md"
                    >
                      <WarningRoundedIcon
                        style={{
                          fontSize: "16px",
                        }}
                      />
                      <p className="m-0 text-sm font-semibold">Missing data points. Please update it from the provider profile.</p>
                    </button>) : ""}
                  <div className="flex gap-6 items-center mb-2">

                    <label className="flex gap-2 items-center cursor-pointer">
                      <input
                        type="radio"
                        name="availabilityType"
                        value="global"
                        checked={availabilityType === "global"}
                        onChange={() => handleAvailabilityTypeChange("global")}
                        className="text-blue-600 focus:ring-blue-500"
                      />
                      <span className="text-sm text-gray-700">
                        Global Availability
                      </span>
                    </label>

                    <label className="flex gap-2 items-center cursor-pointer">
                      <input
                        type="radio"
                        name="availabilityType"
                        value="custom"
                        checked={availabilityType === "custom"}
                        onChange={() => handleAvailabilityTypeChange("custom")}
                        className="text-blue-600 focus:ring-blue-500"
                      />
                      <span className="text-sm text-gray-700">
                        Custom Availability
                      </span>
                    </label>
                  </div>

                  {availabilityType === "custom" && (
                    <div className="p-4 mb-6 bg-gray-100 rounded-lg border border-gray-300">
                      {/* Section Title */}
                      <div className="flex gap-2 items-center mb-1 text-base font-semibold text-gray-800">
                        Custom Availability
                      </div>

                      <div className="pt-3">
                        {isLoadingWeeklyRanges ? (
                          <div className="py-8 text-center text-gray-500">
                            <div className="flex flex-col gap-2 items-center">
                              <div className="w-8 h-8 rounded-full border-4 border-blue-600 animate-spin border-t-transparent"></div>
                              <span>Loading availability data...</span>
                            </div>
                          </div>
                        ) : (
                          <>
                            {/* Filter templates for selected market */}
                            {(() => {
                              // Filter templates based on selected market
                              let filteredTemplates = [];

                              if (selectedMarket === "ALL") {
                                // Show all templates when "ALL" is selected
                                filteredTemplates = weeklyDateRanges;
                              } else {
                                // Show only templates for the selected market
                                filteredTemplates = weeklyDateRanges.filter(template =>
                                  template.provider_market_id === Number(selectedMarket)
                                );
                              }

                              return (
                                <>
                                  <div className="flex flex-col gap-2 max-h-[300px] overflow-auto">
                                    {filteredTemplates.length === 0 ? (
                                      <div className="p-4 text-sm text-center text-gray-500 bg-gray-50 rounded-md border border-gray-300 border-dashed">
                                        {selectedMarket === "ALL"
                                          ? "No templates found."
                                          : `No templates found for ${details.market?.find(m => m.id === Number(selectedMarket))?.market_name || "selected market"}.`
                                        }
                                        {user?.permissions?.includes('provider_settings.edit_weekly_settings') && (
                                          <span
                                            className="block mt-1 font-medium text-blue-600 cursor-pointer hover:underline"
                                            onClick={handleDeselectTemplate}
                                          >
                                            + Add a new template
                                          </span>
                                        )}
                                      </div>
                                    ) : (
                                      filteredTemplates.map((template, index) => {
                                        const workingHours =
                                          template.day_preferences?.ALL?.working_hours || {};
                                        const zipCodes =
                                          template.day_preferences?.ALL?.zip_codes || [];
                                        const assignments = template.assignments || [];
                                        const appointments = template.day_preferences?.ALL?.appointment_type_ids || [];
                                        const start = moment(template.start_date);
                                        const end = moment(template.end_date);
                                        const { label } = getStatus(start, end);

                                        const isBeingEdited = selectedWeeklyDateRange?.id === template.id;
                                        const isReadOnly = shouldDisableFields() && !isBeingEdited;

                                        return (
                                          <div
                                            key={template.id || index}
                                            className={`rounded-lg py-3 px-4 cursor-pointer ${template.id ===
                                              Number(selectedWeeklyDateRange?.id)
                                              ? "border-2 border-blue-400 bg-blue-50"
                                              : "border border-gray-300 bg-white"
                                              }`}
                                            onClick={() => {
                                              handleDateRangeOperation("edit", template, false);
                                              setSelectedDay("ALL");
                                            }}
                                          >
                                            <>
                                              <div className="flex justify-between items-center">
                                                <div>
                                                  <h2 className="font-semibold text-gray-800 text-[14px]">
                                                    {template.template_name || `Template ${template.id}`}
                                                  </h2>
                                                  {selectedMarket === "ALL" && template.provider_market_id && (
                                                    <div className="mt-1 text-xs text-gray-500">
                                                      Market: {details.market?.find(m => m.id === template.provider_market_id)?.market_name || `Market ${template.provider_market_id}`}
                                                    </div>
                                                  )}
                                                </div>
                                                {label !== "Past" && (
                                                  <div className="gap-2 d-flex">
                                                    <button
                                                      className="px-2 py-1 text-xs text-blue-600 rounded hover:bg-blue-100"
                                                      style={{ border: '1px solid #2f80ed' }}
                                                      onClick={(e) => {
                                                        e.stopPropagation();
                                                        handleDateRangeOperation("edit", template, false);
                                                        setSelectedDay("ALL");
                                                        setIsDateRangeModalOpen({ status: true, templateId: template?.id, isEditing: false });
                                                      }}
                                                    >
                                                      Assign Date Range
                                                    </button>
                                                    {user?.permissions?.includes('provider_settings.edit_weekly_settings') && (
                                                      <>
                                                        <button
                                                          className="px-2 py-1 text-xs text-gray-600 rounded border border-gray-600 hover:bg-gray-100"
                                                          onClick={(e) => {
                                                            e.stopPropagation();
                                                            handleEditTemplate(template);
                                                          }}
                                                        >
                                                          Edit
                                                        </button>
                                                        <button
                                                          className="px-2 py-1 text-xs text-gray-600 rounded border border-gray-600 hover:bg-gray-200"
                                                          onClick={(e) => {
                                                            e.stopPropagation();
                                                            handleDateRangeOperation("edit", template, false);
                                                            setIsDeleteRangeModalOpen({ status: true, type: 'template' });
                                                          }}
                                                        >
                                                          Delete
                                                        </button>
                                                      </>
                                                    )}
                                                  </div>
                                                )}
                                              </div>
                                              <div className="flex gap-2 text-[12px] text-gray-700 mt-2">
                                                <div
                                                  className="text-gray-600 truncate max-w-[130px] cursor-default"
                                                  title={template.working_days.join(", ")}
                                                >
                                                  {template.working_days
                                                    .map(
                                                      (day) =>
                                                        day.slice(0, 3).charAt(0) + day.slice(1, 3).toLowerCase()
                                                    )
                                                    .join(", ")}
                                                </div>
                                                <div className="text-gray-600">
                                                  {(() => {
                                                    const to12HourFormat = (time) => {
                                                      if (!time) return null;
                                                      const [hour, minute] = time.split(":").map(Number);
                                                      const ampm = hour >= 12 ? "PM" : "AM";
                                                      const h = hour % 12 || 12;
                                                      return `${h}:${minute.toString().padStart(2, "0")} ${ampm}`;
                                                    };

                                                    const start = workingHours.start || "09:00";
                                                    const end = workingHours.end || "17:00";

                                                    return `${to12HourFormat(start)} - ${to12HourFormat(end)}`;
                                                  })()}
                                                </div>
                                                <div className="text-gray-600">• {appointments.length} appointment types</div>
                                                <div className="text-gray-600">• {zipCodes.length} zip codes</div>
                                              </div>
                                            </>

                                            {/* Show assignments if this template is selected */}
                                            {template.id === Number(selectedWeeklyDateRange?.id) && (
                                              <div className="pt-2 mt-2 text-sm border-t border-gray-300">
                                                {assignments.length === 0 ? (
                                                  <div className="italic text-gray-500">No date ranges assigned.</div>
                                                ) : (
                                                  <div className="flex flex-col gap-2">
                                                    <div className="font-semibold text-gray-700">Applied to Date Ranges</div>
                                                    <div className="flex flex-col gap-2 max-h-[100px] overflow-y-auto no-scrollbar">
                                                      {assignments.map((assign) => {
                                                        const start = moment(assign.start_date);
                                                        const end = moment(assign.end_date);
                                                        const { label, color } = getStatus(start, end);
                                                        const splitRanges = splitRangeByDeletedDates(start, end, assign?.deleted_dates);

                                                        const colorClasses = {
                                                          green: "bg-green-100 text-green-700 border border-green-300",
                                                          yellow: "bg-yellow-100 text-yellow-700 border border-yellow-300",
                                                          red: "bg-red-100 text-red-700 border border-red-300",
                                                        };
                                                        const formatRange = (start, end) => {
                                                          const s = moment(start);
                                                          const e = moment(end);

                                                          if (s.isSame(e, "day")) {
                                                            return s.format("MMM DD");
                                                          }
                                                          if (s.isSame(e, "month")) {
                                                            return `${s.format("MMM DD")}-${e.format("DD")}`;
                                                          }
                                                          return `${s.format("MMM DD")}-${e.format("MMM DD")}`;
                                                        };
                                                        const maxVisible = 3;
                                                        const extraCount = splitRanges.length - maxVisible;

                                                        return (
                                                          <div
                                                            key={assign.id}
                                                            className="flex justify-between items-center p-2 bg-gray-50 rounded-md border border-gray-200"
                                                          >
                                                            <div className="flex gap-1">
                                                              <span className="font-medium text-gray-800 d-flex">
                                                                {splitRanges.slice(0, maxVisible).map((range, index) => (
                                                                  <span key={index} className="text-gray-800">
                                                                    {formatRange(range.start, range.end)}
                                                                    {index < maxVisible - 1 && extraCount >= 0 && (
                                                                      <span className="mx-1 text-gray-400">|</span>
                                                                    )}
                                                                  </span>
                                                                ))}
                                                                {extraCount > 0 && (
                                                                  <Tooltip
                                                                    title={
                                                                      <div style={{ maxWidth: 250 }}>
                                                                        {splitRanges.slice(maxVisible).map((range, i) => (
                                                                          <div key={i}>
                                                                            {formatRange(range.start, range.end)}
                                                                          </div>
                                                                        ))}
                                                                      </div>
                                                                    }
                                                                    placement="top"
                                                                    arrow
                                                                  >
                                                                    <span className="ml-1 text-blue-600 cursor-pointer hover:underline">
                                                                      +{extraCount} more
                                                                    </span>
                                                                  </Tooltip>
                                                                )}
                                                              </span>
                                                            </div>
                                                            <span className="gap-2 d-plex">
                                                              <span
                                                                className={`text-xs px-2 py-0.5 rounded self-start mr-1 ${colorClasses[color]}`}
                                                              >
                                                                {label}
                                                              </span>
                                                              <button
                                                                onClick={(e) => {
                                                                  e.stopPropagation();
                                                                  setIsDeleteRangeModalOpen({ status: true, type: "range", rangeId: assign?.id });
                                                                }}
                                                                className="px-3 py-1 text-xs text-red-600 rounded border border-red-500 hover:bg-red-50"
                                                              >
                                                                Remove
                                                              </button>
                                                            </span>
                                                          </div>
                                                        );
                                                      })}
                                                    </div>
                                                  </div>
                                                )}
                                              </div>
                                            )}
                                          </div>
                                        );
                                      })
                                    )}
                                  </div>

                                  {/* Add New Template Button */}
                                  {user?.permissions?.includes('provider_settings.edit_weekly_settings') && (
                                    <div className="flex justify-end mt-3">
                                      <button
                                        className="px-2 py-1 text-sm font-medium text-white bg-blue-600 rounded-md hover:bg-blue-700"
                                        onClick={() => handleDeselectTemplate('add')}
                                      >
                                        + Add New Template
                                      </button>
                                    </div>
                                  )}
                                </>
                              );
                            })()}
                          </>
                        )}
                      </div>
                    </div>
                  )}

                  {availabilityType === "custom" && isEditMode && selectedWeeklyDateRange && (
                    <div ref={templateCreationRef} className="bg-blue-50 w-[25vw] border-l-4 border-blue-500 p-2 rounded-md mb-6">
                      <p className="mb-0 text-sm font-semibold text-blue-700">
                        Editing Template: <span className="font-medium">{selectedWeeklyDateRange?.template_name}</span>
                      </p>
                      <p className="mb-0 text-xs text-blue-600 whitespace-nowrap">
                        You are currently modifying this availability template.
                      </p>
                    </div>
                  )}

                  {templateMode === "none" && availabilityType === "custom" && !selectedWeeklyDateRange && (
                    <div className="p-3 mb-4 bg-blue-50 rounded-lg border border-blue-200" ref={templateCreationRef}>
                      <div className="flex gap-2 items-center text-sm text-blue-800">
                        <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
                          <path
                            fillRule="evenodd"
                            d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z"
                            clipRule="evenodd"
                          />
                        </svg>
                        <span>
                          Creating New Template: Configure the settings below and click <span className="font-medium">"Create Template"</span> to save it.
                        </span>
                      </div>
                    </div>
                  )}


                  <div className="pb-0 bg-white">
                    {/* Availability Section */}
                    <div className="mb-4">
                      <div className="flex justify-between items-center mb-2">
                        <h3 className="text-base font-semibold">
                          Availability
                          <button
                            className="ml-2 text-sm"
                            onClick={handleSelectAll}
                            disabled={
                              !user?.permissions?.includes(
                                "provider_settings.edit_weekly_settings"
                              ) || (
                                availabilityType === "custom" &&
                                selectedWeeklyDateRange &&
                                !isEditMode
                              )
                            }
                          >
                            (<span className="text-blue-500">select all</span>)
                          </button>
                        </h3>
                      </div>

                      <div className="flex flex-wrap gap-2 mb-4">
                        {days.map((day, index) => (
                          <div key={day} className="flex items-center">
                            <input
                              type="checkbox"
                              id={`day-${index}`}
                              className="w-5 h-5 text-blue-600 rounded border-gray-300 focus:ring-blue-500"
                              checked={selectedDays?.includes(day)}
                              onChange={() => {
                                setHasUnsavedChanges(true);
                                if (selectedDays?.includes(day)) {
                                  setSelectedDays(
                                    selectedDays?.filter((data) => data !== day)
                                  );
                                } else {
                                  setSelectedDays([...selectedDays, day]);
                                }
                              }}
                              disabled={!user?.permissions?.includes('provider_settings.edit_provider_settings') ||
                                (
                                  availabilityType === "custom" &&
                                  selectedWeeklyDateRange &&
                                  !isEditMode
                                )
                              }
                            />
                            <label
                              htmlFor={`day-${index}`}
                              className="ml-2 text-sm text-gray-700"
                            >
                              {day[0] + day.substring(1).toLowerCase()}
                            </label>
                          </div>
                        ))}
                      </div>
                    </div>

                    {/* Day-specific settings tabs */}
                    <div className="overflow-hidden rounded-lg border">
                      <div className="flex overflow-x-auto bg-gray-100 border-b">
                        <button
                          onClick={() => {
                            setSelectedDay("ALL");
                            setDayPreferences((prev) => {
                              return { ...prev };
                            });
                          }}
                          className={`px-4 py-2 text-sm font-medium whitespace-nowrap ${selectedDay === "ALL"
                            ? "bg-white border-t-2 border-blue-600"
                            : "text-gray-600"
                            }`}
                        >
                          All Days
                        </button>
                        {days.map((day) => (
                          <button
                            key={day}
                            onClick={() => {
                              setSelectedDay(day);
                              setDayPreferences((prev) => {

                                return { ...prev };
                              });
                            }}
                            className={`px-4 py-2 text-sm font-medium whitespace-nowrap ${selectedDay === day
                              ? "bg-white border-t-2 border-blue-600"
                              : "text-gray-600"
                              } ${!selectedDays?.includes(day)
                                ? "opacity-50 cursor-not-allowed"
                                : ""
                              }`}
                            disabled={!selectedDays?.includes(day)}
                          >
                            {day[0] + day.substring(1)?.toLowerCase()}
                          </button>
                        ))}
                      </div>

                      <div className="p-4">
                        {selectedDay !== "ALL" && (
                          <div className="p-3 mb-4 bg-blue-50 rounded border border-blue-200">
                            <p className="flex items-center text-sm text-blue-800">
                              <svg
                                xmlns="<http://www.w3.org/2000/svg>"
                                width="16"
                                height="16"
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="currentColor"
                                strokeWidth="2"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                className="mr-2"
                              >
                                <circle cx="12" cy="12" r="10"></circle>
                                <line x1="12" y1="16" x2="12" y2="12"></line>
                                <line x1="12" y1="8" x2="12.01" y2="8"></line>
                              </svg>
                              <span>
                                You are configuring settings for{" "}
                                <strong>
                                  {selectedDay[0] +
                                    selectedDay.substring(1).toLowerCase()}
                                </strong>{" "}
                                only. These settings will override the general
                                settings.
                              </span>
                            </p>
                          </div>
                        )}

                        {/* Target Visits */}
                        {/* <div className="mb-6">
                        <h3 className="mb-2 text-lg font-medium">
                          Target Visits{" "}
                          {selectedDay !== "ALL"
                            ? `for ${
                                selectedDay[0] +
                                selectedDay.substring(1).toLowerCase()
                              }`
                            : "Per Day"}
                        </h3>
                        <select
                          className="p-2 w-40 rounded border border-gray-300"
                          value={
                            dayPreferences?.[selectedDay]?.visits_count || null
                          }
                          onChange={(e) => {
                            setDayPreferences((prev) => {
                              return {
                                ...prev,
                                [selectedDay]: {
                                  ...prev?.[selectedDay],
                                  visits_count: e.target.value,
                                },
                              };
                            });
                          }}
                        >
                          <option key={0} value={null}>
                            N/A
                          </option>
                          {[...Array(30)].map((_, i) => (
                            <option key={i + 1} value={i + 1}>
                              {i + 1}
                            </option>
                          ))}
                        </select>
                      </div> */}

                        {/* Working Hours */}
                        {/* {selectedDay !== "ALL" && ( */}
                        <div className="mb-6">
                          <h3 className="mb-2 text-base font-semibold">
                            Working Hours{" "}
                            {selectedDay !== "ALL" &&
                              " for " +
                              selectedDay[0] +
                              selectedDay.substring(1).toLowerCase()}
                          </h3>
                          <div className="grid grid-cols-2 gap-4">
                            <div>
                              <label className="block mb-1 text-sm font-medium text-gray-700">
                                Start Time
                              </label>
                              <select
                                className="p-2 w-full text-sm rounded border border-gray-300"
                                disabled={
                                  !user?.permissions?.includes(
                                    "provider_settings.edit_weekly_settings"
                                  ) || (
                                    availabilityType === "custom" &&
                                    selectedWeeklyDateRange &&
                                    !isEditMode
                                  )
                                }
                                value={(() => {
                                  const dayWorkingHours = dayPreferences?.[selectedDay]?.working_hours;
                                  const allWorkingHours = dayPreferences?.["ALL"]?.working_hours;

                                  // Prefer the selected day's start_time, else fallback to ALL's start_time
                                  const start_time =
                                    dayWorkingHours?.start ?? allWorkingHours?.start ?? null;

                                  // if (start_time && providerTimezone) {
                                  //   try {
                                  //     return getProviderTimezoneTime(
                                  //       start_time,
                                  //       providerTimezone
                                  //     );
                                  //   } catch (err) {
                                  //     return start_time;
                                  //   }
                                  // }

                                  return start_time || "09:00";
                                })()}
                                onChange={(e) => {
                                  setDayPreferencesWithDirty((prev) => {
                                    return {
                                      ...prev,
                                      [selectedDay]: {
                                        ...prev?.[selectedDay],
                                        working_hours: {
                                          ...prev?.[selectedDay]?.working_hours,
                                          start: e.target.value
                                        },
                                      },
                                    };
                                  });
                                }}
                              >
                                {Array.from({ length: 48 }, (_, i) => {
                                  const hours = String(
                                    Math.floor(i / 2)
                                  ).padStart(2, "0");
                                  const minutes = i % 2 === 0 ? "00" : "30";
                                  const time = `${hours}:${minutes}`;
                                  return (
                                    <option key={time} value={time}>
                                      {moment(time, "HH:mm").format("hh:mm A")}
                                    </option>
                                  );
                                })}
                              </select>
                            </div>
                            <div>
                              <label className="block mb-1 text-sm font-medium text-gray-700">
                                End Time
                              </label>
                              <select
                                className="p-2 w-full text-sm rounded border border-gray-300"
                                disabled={
                                  !user?.permissions?.includes(
                                    "provider_settings.edit_weekly_settings"
                                  ) || (
                                    availabilityType === "custom" &&
                                    selectedWeeklyDateRange &&
                                    !isEditMode
                                  )
                                }
                                value={(() => {
                                  // const workingHours =
                                  //   dayPreferences?.[selectedDay]?.working_hours;
                                  // const { end: end_time } = workingHours || {};
                                  const dayWorkingHours = dayPreferences?.[selectedDay]?.working_hours;
                                  const allWorkingHours = dayPreferences?.["ALL"]?.working_hours;

                                  // Prefer the selected day's start_time, else fallback to ALL's start_time
                                  const end_time =
                                    dayWorkingHours?.end ?? allWorkingHours?.end ?? null;

                                  // if (end_time && providerTimezone) {
                                  //   try {
                                  //     return getProviderTimezoneTime(
                                  //       end_time,
                                  //       providerTimezone
                                  //     );
                                  //   } catch (err) {
                                  //     return end_time;
                                  //   }
                                  // }

                                  return end_time || "17:00";
                                })()}
                                onChange={(e) => {
                                  setDayPreferencesWithDirty((prev) => {
                                    return {
                                      ...prev,
                                      [selectedDay]: {
                                        ...prev?.[selectedDay],
                                        working_hours: {
                                          ...prev?.[selectedDay]?.working_hours,
                                          end: e.target.value
                                        },
                                      },
                                    };
                                  });
                                }}
                              >
                                {Array.from({ length: 48 }, (_, i) => {
                                  const hours = String(
                                    Math.floor(i / 2)
                                  ).padStart(2, "0");
                                  const minutes = i % 2 === 0 ? "00" : "30";
                                  const time = `${hours}:${minutes}`;
                                  return (
                                    <option key={time} value={time}>
                                      {moment(time, "HH:mm").format("hh:mm A")}
                                    </option>
                                  );
                                })}
                              </select>
                            </div>
                          </div>
                        </div>

                        <div className="mb-6">
                          {/* <h3 className="mb-4 text-base font-semibold">
                          Geographic Coverage{" "}
                          {selectedDay !== "ALL"
                            ? `for ${selectedDay[0] +
                            selectedDay.substring(1).toLowerCase()
                            }`
                            : ""}
                        </h3> */}

                          {/* {selectedDay !== "ALL" && (
                          <>
                            <div className="flex items-center mb-4">
                              <input
                                type="checkbox"
                                id={`inherit-geo-${selectedDay}`}
                                className="w-5 h-5 text-blue-600 rounded border-gray-300 focus:ring-blue-500"
                                checked={defaultGeographicCoverage}
                                onChange={(e) => {
                                  setDefaultGeographicCoverage(
                                    e.target.checked
                                  );
                                  if (e.target.checked) {
                                    setDayPreferences((prev) => {
                                      return {
                                        ...prev,
                                        [selectedDay]: {
                                          ...prev?.[selectedDay],
                                          zone_ids: [],
                                          zip_codes: [],
                                        },
                                      };
                                    });
                                  }
                                }}
                              />
                              <label
                                htmlFor={`inherit-geo-${selectedDay}`}
                                className="ml-2 text-gray-700"
                              >
                                Use same geographic coverage as general settings
                              </label>
                            </div>
                          </>
                        )} */}

                          {/* <div className="flex mb-2">
                          <button
                            onClick={() => setSelectedCoverage("default")}
                            className={`px-3 py-1 text-sm rounded-l ${selectedCoverage === "default"
                              ? "bg-blue-600 text-white"
                              : "bg-gray-200 text-gray-700"
                              }`}
                          >
                            Use Default Coverage
                          </button>
                          <button
                            onClick={() => setSelectedCoverage("custom")}
                            className={`px-3 py-1 text-sm rounded-r ${selectedCoverage === "custom"
                              ? "bg-blue-600 text-white"
                              : "bg-gray-200 text-gray-700"
                              }`}
                          >
                            Custom Coverage
                          </button>
                        </div> */}

                          <GeographicCoverageSection
                            selectedDay={selectedDay}
                            dayPreferences={dayPreferences}
                            setDayPreferences={setDayPreferencesWithDirty}
                            providerId={details.id}
                            fetchProviderZipCodes={fetchProviderZipCodes}
                            disabled={
                              !user?.permissions?.includes(
                                "provider_settings.edit_weekly_settings"
                              ) || (
                                availabilityType === "custom" &&
                                selectedWeeklyDateRange &&
                                !isEditMode
                              )
                            }
                            marketId={selectedMarket}
                          />
                        </div>
                      </div>
                    </div>

                    {/* Leaves Section */}
                    {/* <div className="pt-6 mb-8 border-t">
                  <h3 className="mb-4 text-lg font-medium">Leaves</h3>

                  <div className="grid grid-cols-4 gap-4 mb-4">
                    <div>
                      <label className="block mb-1 text-sm font-medium text-gray-700">
                        Absence Type
                      </label>
                      <select className="p-2 w-full rounded border border-gray-300">
                        <option>Select</option>
                      </select>
                    </div>
                    <div>
                      <label className="block mb-1 text-sm font-medium text-gray-700">
                        Start Date
                      </label>
                      <input
                        type="text"
                        placeholder="mm/dd/yyyy"
                        className="p-2 w-full rounded border border-gray-300"
                      />
                    </div>
                    <div>
                      <label className="block mb-1 text-sm font-medium text-gray-700">
                        End Date
                      </label>
                      <input
                        type="text"
                        placeholder="mm/dd/yyyy"
                        className="p-2 w-full rounded border border-gray-300"
                      />
                    </div>
                    <div className="flex items-end">
                      <button className="px-6 py-2 text-white bg-blue-600 rounded">
                        Add
                      </button>
                    </div>
                  </div>
                </div> */}

                    {/* Time Off Section */}
                    {/* <div className="pt-6 mb-8 border-t">
                  <h3 className="mb-4 text-lg font-medium">Time Off</h3>
                  <div className="flex justify-between pb-2 text-sm text-gray-600 border-b">
                    <span className="w-1/4">Name</span>
                    <span className="w-1/4">Type</span>
                    <span className="w-1/4">Start Date</span>
                    <span className="w-1/4">End Date</span>
                  </div>
                  <div className="py-4 text-center text-gray-500">
                    No time off entries
                  </div>
                </div> */}

                    {/* Action Buttons */}
                    {/* <div className="flex gap-4 justify-end pt-4">
                  <button className="px-8 py-2 font-medium text-blue-600 rounded border border-blue-600">
                    Cancel
                  </button>
                  <button className="px-8 py-2 font-medium text-white bg-blue-600 rounded">
                    Save
                  </button>
                </div> */}
                  </div>

                  <div>
                    <h3 className="mt-3 mb-2 text-base font-semibold">
                      Appointment Types
                    </h3>
                    <p className="mb-3 text-sm text-gray-500">
                      Select the appointment types this provider can service:
                    </p>

                    <div className="grid grid-cols-3 gap-3 md:grid-cols-4">
                      <label className="flex gap-2 items-center text-sm text-gray-700">
                        <input
                          type="checkbox"
                          disabled={
                            !user?.permissions?.includes(
                              "provider_settings.edit_weekly_settings"
                            ) || (
                              availabilityType === "custom" &&
                              selectedWeeklyDateRange &&
                              !isEditMode
                            )
                          }
                          checked={
                            appointmentTypes.length > 0 &&
                            appointmentTypes.every((type) =>
                              dayPreferences?.[
                                selectedDay
                              ]?.appointment_type_ids?.includes(type.id)
                            )
                          }
                          onChange={(e) => {
                            setDayPreferencesWithDirty((prev) => {
                              const defaultTypes =
                                prev?.["ALL"]?.appointment_type_ids || [];
                              const newTypes = e.target.checked
                                ? appointmentTypes.map((type) => type.id)
                                : [];

                              // Check if the new selection differs from default types
                              const hasNonDefaultTypes = newTypes.some(
                                (id) => !defaultTypes.includes(id)
                              );
                              const hasMissingDefaultTypes = defaultTypes.some(
                                (id) => !newTypes.includes(id)
                              );

                              if (hasNonDefaultTypes || hasMissingDefaultTypes) {
                                setDefaultAppointmentTypes(false);
                              }

                              return {
                                ...prev,
                                [selectedDay]: {
                                  ...prev?.[selectedDay],
                                  appointment_type_ids: newTypes,
                                },
                              };
                            });
                          }}
                          className="w-4 h-4 text-blue-600"
                        />
                        Select All
                      </label>
                      {appointmentTypes?.map((type) => (
                        <label
                          key={type?.id}
                          className="flex gap-2 items-center text-sm text-gray-700"
                        >
                          <input
                            type="checkbox"
                            disabled={
                              !user?.permissions?.includes(
                                "provider_settings.edit_weekly_settings"
                              ) || (
                                availabilityType === "custom" &&
                                selectedWeeklyDateRange &&
                                !isEditMode
                              )
                            }
                            checked={
                              dayPreferences?.[
                                selectedDay
                              ]?.appointment_type_ids?.includes(type?.id) || false
                            }
                            onChange={(e) => {
                              setDayPreferencesWithDirty((prev) => {
                                const prevTypes =
                                  prev?.[selectedDay]?.appointment_type_ids || [];
                                const defaultTypes =
                                  prev?.["ALL"]?.appointment_type_ids || [];
                                let newTypes;

                                if (e.target.checked) {
                                  newTypes = [...prevTypes, type.id];
                                } else {
                                  newTypes = prevTypes.filter(
                                    (id) => id !== type.id
                                  );
                                }

                                // Check if the new selection differs from default types
                                const hasNonDefaultTypes = newTypes.some(
                                  (id) => !defaultTypes.includes(id)
                                );
                                const hasMissingDefaultTypes = defaultTypes.some(
                                  (id) => !newTypes.includes(id)
                                );

                                if (
                                  hasNonDefaultTypes ||
                                  hasMissingDefaultTypes
                                ) {
                                  setDefaultAppointmentTypes(false);
                                }

                                return {
                                  ...prev,
                                  [selectedDay]: {
                                    ...prev?.[selectedDay],
                                    appointment_type_ids: newTypes,
                                  },
                                };
                              });
                            }}
                            className="w-4 h-4 text-blue-600"
                          />
                          {type?.name}
                        </label>
                      ))}
                    </div>
                  </div>
                </>
              )}
              {activeTab === 1 && (
                <>
                  <Calendar
                    isCalendarOpen={true}
                    isModal={false}
                    isMultiDayAvailability={true}
                    provideIdAv={details.id}
                    showAlert={showAlert}
                    provider={providerDetails}
                    providerDefaultZones={defaultZones}
                    providerWeeklyAvailability={details}
                    leaves={leaves}
                    dayPreferences={dayPreferences}
                    upsertProviderConstraint={upsertProviderConstraint}
                    setDayPreferences={setDayPreferencesWithDirty}
                    workingDays={selectedDays}
                    setSelectedDays={setSelectedDaysWithDirty}
                    providerTimezone={providerTimezone}
                    weeklyDateRanges={weeklyDateRanges}
                    selectedWeeklyDateRange={selectedWeeklyDateRange}
                    getWeeklyDateRanges={getWeeklyDateRanges}
                    marketId={selectedMarket}
                    markets={details?.market}
                  />
                </>
              )}
              {activeTab === 2 && (
                <div className="overflow-auto">
                  {/* <div className="w-full border border-primarygrayborder" />
              <div className="flex flex-col gap-4 justify-between items-start p-4">
                <div className="flex justify-between items-center w-full">
                  <h1 className="m-0 text-lg font-bold">
                    Availability
                    <button className="ml-2 text-base" onClick={handleSelectAll}>
                      (
                      <span className="underline text-primaryblue">select all</span>
                      )
                    </button>
                  </h1>
                  <button
                    className="px-2 py-1 ml-1 bg-gray-200 rounded-md text-grey-700 hover:text-primaryblue calendar-icon"
                    onClick={() => {
                      setIsCalenderOpen(true);
                      setEditModalOpen(false);
                    }}
                  >
                    <CalendarMonthIcon />
                  </button>
                </div>
                <div className="flex flex-row flex-wrap gap-2 w-full">
                  {days.map((data, index) => (
                    <label
                      key={index}
                      className="flex flex-row gap-2 items-center row-gap-4"
                    >
                      <input
                        type="checkbox"
                        className="w-4 h-4 checked:lightblue"
                        checked={selectedDays.includes(data)}
                        onChange={() => {
                          if (selectedDays.includes(data)) {
                            setSelectedDays(
                              selectedDays.filter((day) => day !== data)
                            );
                          } else {
                            setSelectedDays([...selectedDays, data]);
                          }
                        }}
                      />
                      <p className="m-0 text-sm">
                        {data[0] + data.substring(1).toLowerCase()}
                      </p>
                    </label>
                  ))}
                </div>
              </div> */}
                  {/* <div className="w-full border border-primarygrayborder" />
              <div className="flex flex-row justify-between items-center divide-x-2">
                <div className="flex flex-col gap-4 justify-start items-start p-4 w-full">
                  <p className="m-0 font-bold">Target Visits Per Day</p>
                  <select
                    className="block p-2 text-sm text-gray-900 bg-white rounded-lg border border-gray-300 w-fit focus:ring-blue-500 focus:border-blue-500"
                    value={visitsPerDay}
                    onChange={(e) => setVisitsPerDay(e.target.value)}
                  >
                    <option value={null}>Select</option>
                    {Array.from({ length: 26 }, (_, i) => i + 5).map(
                      (data, index) => (
                        <option key={index} value={data}>
                          {data}
                        </option>
                      )
                    )}
                  </select>
                </div>
              </div> */}
                  {/* <div className="w-full border border-primarygrayborder" /> */}
                  {/* <div className="flex flex-row gap-4 items-center">
                  <div className="flex flex-col gap-4 justify-start items-start py-6 pl-6 w-full">
                    <p className="m-0 font-bold">Leaves</p>
                    <div className="flex flex-row gap-4 items-center">
                      <input
                        type="text"
                        className="p-2 text-sm text-gray-900 bg-white rounded-lg border border-gray-300 w-fit focus:ring-blue-500 focus:border-blue-500"
                        placeholder="Name"
                        value={name}
                        onChange={(e) => setName(e.target.value)}
                      />
                    </div>
                  </div>
                  <div className="flex flex-col gap-4 justify-start items-start py-6 w-full">
                    <p className="m-0 font-bold">Absence Type</p>
                    <div className="flex flex-row gap-4 items-center">
                      <select
                        className="block h-[38px] p-2 text-sm text-gray-900 bg-white border border-gray-300 rounded-lg w-fit focus:ring-blue-500 focus:border-blue-500"
                        value={type}
                        onChange={(e) => setType(e.target.value)}
                      >
                        <option value={""}>Select</option>
                        <option value={"GEN"}>Unpaid Absence</option>
                        <option value={"PTO"}>PTO</option>
                      </select>
                    </div>
                  </div>
                  <div className="flex flex-col gap-4 justify-start items-start py-6 w-full">
                    <p className="m-0 font-bold">Start Date</p>
                    <div className="flex flex-row gap-4 items-center">
                      <input
                        type="date"
                        className="p-2 text-sm text-gray-900 bg-white rounded-lg border border-gray-300 w-fit focus:ring-blue-500 focus:border-blue-500"
                        placeholder="Start date"
                        min={moment().format("YYYY-MM-DD")}
                        value={startDate}
                        onChange={(e) => setStartDate(e.target.value)}
                      />
                      <input
                        type="time"
                        className="p-2 text-sm text-gray-900 bg-white rounded-lg border border-gray-300 w-fit focus:ring-blue-500 focus:border-blue-500"
                        value={startTime}
                        onChange={(e) => setStartTime(e.target.value)}
                      />
                    </div>
                  </div>
                  <div className="flex flex-col gap-4 justify-start items-start py-6 pr-6 w-full">
                    <p className="m-0 font-bold">End Date</p>
                    <div className="flex flex-row gap-4 items-center">
                      <input
                        type="date"
                        className="p-2 text-sm text-gray-900 bg-white rounded-lg border border-gray-300 w-fit focus:ring-blue-500 focus:border-blue-500"
                        placeholder="End date"
                        value={endDate}
                        min={startDate}
                        onChange={(e) => setEndDate(e.target.value)}
                      />
                      <input
                        type="time"
                        className="p-2 text-sm text-gray-900 bg-white rounded-lg border border-gray-300 w-fit focus:ring-blue-500 focus:border-blue-500"
                        value={endTime}
                        onChange={(e) => setEndTime(e.target.value)}
                      />
                      {!ptoToEdit ? (
                        <button
                          className="px-4 py-2 text-sm font-bold text-white rounded-lg bg-primaryblue"
                          onClick={createProviderLeave}
                        >
                          Add
                        </button>
                      ) : (
                        <div className="flex flex-row gap-2">
                          <button
                            className="px-4 py-2 text-sm font-bold text-white bg-gray-400 rounded-lg"
                            onClick={() => {
                              handleEditClickPTO(null);
                            }}
                          >
                            Cancel
                          </button>
                          <button
                            className="px-4 py-2 text-sm font-bold text-white rounded-lg bg-primaryblue"
                            onClick={() => {
                              updateProviderLeave(ptoToEdit.id);
                            }}
                          >
                            Save
                          </button>
                        </div>
                      )}
                    </div>
                  </div>
                </div> */}

                  <div className="flex justify-between items-center px-6" >
                    <p
                      className="text-base font-semibold cursor-pointer"
                      onClick={toggleLeaveForm}
                    >
                      Apply Time Off
                    </p>
                    <button
                      onClick={toggleLeaveForm}
                      className="flex gap-1 items-center text-gray-600 transition hover:text-black"
                      aria-label="Toggle Absence Form"
                    >
                      <span className="mr-2 text-sm">
                        (
                        <a className="text-blue-600 hover:underline">
                          {showLeaveForm ? "Collapse" : "Expand"}
                        </a>
                        )
                      </span>
                      {showLeaveForm ? (
                        <FaChevronUp size={18} />
                      ) : (
                        <FaChevronDown size={18} />
                      )}
                    </button>
                  </div>

                  {showLeaveForm &&
                    user?.permissions?.includes(
                      "provider_settings.edit_time_off"
                    ) && (
                      <>
                        <div className="w-full border border-primarygrayborder" ref={leaveFormRef} />
                        <div className="grid grid-cols-1 gap-3 px-3 py-3 md:grid-cols-3">
                          {/* Name */}
                          {/* <div className="flex flex-col gap-2">
                          <label className="font-bold">Name</label>
                          <input
                            type="text"
                            className="p-2 text-sm text-gray-900 bg-white rounded-lg border border-gray-300 focus:ring-blue-500 focus:border-blue-500"
                            placeholder="Name"
                            value={name}
                            onChange={(e) => setName(e.target.value)}
                          />
                        </div> */}

                          {/* Absence Type */}
                          <div className="flex flex-col gap-2">
                            <label className="text-sm font-semibold">
                              Absence Type
                            </label>
                            <select
                              className="h-[38px] p-2 text-sm text-gray-900 bg-white border border-gray-300 rounded-lg focus:ring-blue-500 focus:border-blue-500"
                              value={type}
                              onChange={(e) => setType(e.target.value)}
                            >
                              <option value={""}>Select</option>
                              {/* <option value={"GEN"}>Unpaid Absence</option>
                            <option value={"PTO"}>PTO</option> */}
                              <option value={"VACATION"}>Vacation</option>
                              <option value={"MEETING"}>Meeting</option>
                              <option value={"TRAINING"}>Training</option>
                              <option value={"MEDICAL"}>Sick</option>
                              <option value={"ADMINISTRATIVE_TIME"}>
                                Administrative Time
                              </option>
                              <option value={"COMPANY_WIDE_ABSENCE"}>
                                Company Wide Absence
                              </option>
                            </select>
                            {isSubmitted && !type && (
                              <span className="text-sm text-red-500">
                                Absence Type is required
                              </span>
                            )}
                          </div>

                          {/* Start Date + Time */}
                          <div className="flex flex-col gap-2">
                            <label className="text-sm font-semibold">
                              Start Date{showHours && " & Time"}
                            </label>
                            <div className={`flex flex-row gap-2`}>
                              <div
                                className={`flex flex-col ${showHours ? "w-3/5" : "w-full"
                                  }`}
                              >
                                <input
                                  type="date"
                                  className={`p-2 w-full text-sm text-gray-900 bg-white rounded-lg border border-gray-300 focus:ring-blue-500 focus:border-blue-500`}
                                  min={moment().format("YYYY-MM-DD")}
                                  value={startDate}
                                  onChange={(e) => setStartDate(e.target.value)}
                                />
                                {isSubmitted && !startDate && (
                                  <span className="text-sm text-red-500">
                                    Start Date is required
                                  </span>
                                )}
                              </div>

                              {showHours && (
                                <div className="flex flex-col w-2/5">
                                  {/* <input
                                type="time"
                                className="p-2 w-2/5 text-sm text-gray-900 bg-white rounded-lg border border-gray-300 focus:ring-blue-500 focus:border-blue-500"
                                value={startTime}
                                onChange={(e) => setStartTime(e.target.value)}
                              /> */}
                                  <select
                                    className="p-2 w-full text-sm text-gray-900 bg-white rounded-lg border border-gray-300 focus:ring-blue-500 focus:border-blue-500"
                                    value={startTime}
                                    onChange={(e) => setStartTime(e.target.value)}
                                  >
                                    <option key="" value="">
                                      Select Time
                                    </option>
                                    {Array.from({ length: 48 }, (_, i) => {
                                      const hours = String(
                                        Math.floor(i / 2)
                                      ).padStart(2, "0");
                                      const minutes = i % 2 === 0 ? "00" : "30";
                                      const time = `${hours}:${minutes}`;
                                      return (
                                        <option key={time} value={time}>
                                          {moment(time, "HH:mm").format(
                                            "hh:mm A"
                                          )}
                                        </option>
                                      );
                                    })}
                                  </select>
                                  {isSubmitted && !startTime && (
                                    <span className="text-sm text-red-500">
                                      Start Time is required
                                    </span>
                                  )}
                                </div>
                              )}
                            </div>
                          </div>

                          {/* End Date + Time */}
                          <div className="flex flex-col gap-2">
                            <label className="text-sm font-semibold">
                              End Date{showHours && " & Time"}
                            </label>
                            <div className={`flex flex-row gap-2`}>
                              <div className="flex flex-col w-full">
                                <input
                                  type="date"
                                  className={`p-2 text-sm text-gray-900 bg-white border border-gray-300 rounded-lg w-full focus:ring-blue-500 focus:border-blue-500 ${showHours ? "w-3/5" : "w-full"
                                    }`}
                                  value={endDate}
                                  min={startDate}
                                  onChange={(e) => setEndDate(e.target.value)}
                                />
                                {isSubmitted && !endDate && (
                                  <span className="text-sm text-red-500">
                                    End Date is required
                                  </span>
                                )}
                              </div>
                              {showHours && (
                                <div className="flex flex-col w-2/5">
                                  {/* <input
                                 type="time"
                                 className="p-2 w-2/5 text-sm text-gray-900 bg-white rounded-lg border border-gray-300 focus:ring-blue-500 focus:border-blue-500"
                                 value={endTime}
                                 onChange={(e) => setEndTime(e.target.value)}
                              /> */}

                                  <select
                                    className="p-2 text-sm text-gray-900 bg-white rounded-lg border border-gray-300 focus:ring-blue-500 focus:border-blue-500"
                                    value={endTime}
                                    onChange={(e) => setEndTime(e.target.value)}
                                  >
                                    <option key="" value="">
                                      Select Time
                                    </option>
                                    {Array.from({ length: 48 }, (_, i) => {
                                      const hours = String(
                                        Math.floor(i / 2)
                                      ).padStart(2, "0");
                                      const minutes = i % 2 === 0 ? "00" : "30";
                                      const time = `${hours}:${minutes}`;
                                      return (
                                        <option key={time} value={time}>
                                          {moment(time, "HH:mm").format(
                                            "hh:mm A"
                                          )}
                                        </option>
                                      );
                                    })}
                                  </select>
                                  {isSubmitted && !endTime && (
                                    <span className="text-sm text-red-500">
                                      End Time is required
                                    </span>
                                  )}
                                </div>
                              )}
                            </div>
                          </div>

                          <div className="flex flex-col gap-2 md:col-span-3">
                            <label className="text-sm font-semibold">Absence Details</label>
                            <textarea
                              className="p-2 text-sm text-gray-900 bg-white rounded-lg border border-gray-300 resize-none focus:ring-blue-500 focus:border-blue-500"
                              placeholder="Provide details about this absence..."
                              rows="3"
                              value={description}
                              onChange={(e) => setDescription(e.target.value)}
                            />
                          </div>
                          {/* Hours of Availability */}
                          <div className="flex col-span-1 gap-2 items-center md:col-span-2">
                            <input
                              type="checkbox"
                              id="showHours"
                              checked={showHours}
                              onChange={(e) => setShowHours(e.target.checked)}
                              className="w-4 h-4"
                            />
                            <label
                              htmlFor="showHours"
                              className="text-sm font-medium text-gray-700"
                            >
                              Hours of Availability
                            </label>
                          </div>

                          {/* Buttons */}
                          <div className="flex col-span-1 gap-4 items-end md:col-span-2">
                            {!ptoToEdit ? (
                              <button
                                className="px-4 py-2 text-sm font-bold text-white rounded-lg bg-primaryblue"
                                onClick={() => createProviderLeave(false)}
                              >
                                Add
                              </button>
                            ) : (
                              <div className="flex flex-row gap-2">
                                <button
                                  className="px-4 py-2 text-sm font-bold text-white bg-gray-400 rounded-lg"
                                  onClick={() => {
                                    setIsSubmitted(false);
                                    handleEditClickPTO(null);
                                  }}
                                >
                                  Cancel
                                </button>
                                <button
                                  className="px-4 py-2 text-sm font-bold text-white rounded-lg bg-primaryblue"
                                  onClick={() =>
                                    updateProviderLeave(ptoToEdit.id, false)
                                  }
                                >
                                  Save
                                </button>
                              </div>
                            )}
                          </div>
                        </div>
                      </>
                    )}

                  <div className="w-full border border-primarygrayborder" />
                  <div className="overflow-auto p-2 max-h-96 no-scrollbar">
                    <p className="text-base font-semibold">
                      {/* You have {details.ptos} leave{details.ptos > 1 ? "s" : ""} */}
                      Time Off
                    </p>
                    <div className="overflow-auto max-h-52">
                      <table className="w-full text-sm">
                        <thead>
                          <tr className="text-left bg-primarylightgrey">
                            {/* <th className="px-4 py-3">Name</th> */}
                            <th className="px-4 py-3">Type</th>
                            <th className="px-4 py-3">Start Date</th>
                            <th className="px-4 py-3">End Date</th>
                            <th className="px-4 py-3">Details</th>
                            {user?.permissions?.includes(
                              "provider_settings.edit_time_off"
                            ) && <th className="px-4 py-3"></th>}
                          </tr>
                        </thead>
                        <tbody>
                          {leaves.map((pto, index) => (
                            <tr
                              className="text-left text-gray-900 border-bottom"
                              key={index}
                            >
                              {/* <td className="px-4 py-3">{pto.name}</td> */}
                              <td className="px-4 py-3">
                                {capitalizeFirstWords(
                                  LEAVE_TYPE[pto.type].replaceAll("_", " ")
                                )}
                              </td>
                              <td className="px-4 py-3">
                                {pto.startTime
                                  ? `${moment(pto.startDate).format(
                                    "MM/DD/YYYY"
                                  )} (${moment(
                                    // getProviderTimezoneTime(
                                    //   pto.startTime,
                                    //   providerTimezone
                                    // ),
                                    pto.startTime,
                                    "HH:mm"
                                  ).format("hh:mm A")})`
                                  : moment(pto.startDate).format("MM/DD/YYYY")}
                              </td>
                              <td className="px-4 py-3">
                                {pto.endTime
                                  ? `${moment(pto.endDate).format(
                                    "MM/DD/YYYY"
                                  )} (${moment(
                                    // getProviderTimezoneTime(
                                    //   pto.endTime,
                                    //   providerTimezone
                                    // ),
                                    pto.endTime,
                                    "HH:mm"
                                  ).format("hh:mm A")})`
                                  : moment(pto.endDate).format("MM/DD/YYYY")}
                              </td>
                              <td className="px-4 py-3 max-w-[200px] truncate" title={pto.details}>
                                {pto.details
                                  ? pto?.details

                                  : '-'}
                              </td>
                              {user?.permissions?.includes(
                                "provider_settings.edit_time_off"
                              ) && (
                                  <td className="flex flex-row gap-2 items-center px-4 py-3">
                                    <button
                                      // className="p-2 text-white bg-gray-200 rounded-md"
                                      className="flex p-2 text-white bg-gray-200 rounded-md"
                                      onClick={() => {
                                        handleEditClickPTO(pto);
                                        setShowLeaveForm(true);
                                      }}
                                    >
                                      <IconComponent
                                        tooltip={"Edit provider Time off"}
                                        icon="Edit_Icon"
                                        i={pto.id}
                                        key={pto.id}
                                      />
                                    </button>
                                    <button
                                      // className="p-2 text-white bg-gray-200 rounded-md"
                                      className="flex p-2 text-white bg-gray-200 rounded-md"
                                      onClick={() => {
                                        deleteProviderLeave(pto.id);
                                      }}
                                    >
                                      <IconComponent
                                        tooltip={"Delete provider Time off"}
                                        icon="Delete_Icon"
                                        i={pto.id}
                                        key={pto.id}
                                      />
                                    </button>
                                  </td>
                                )}
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                  <div className="w-full border border-primarygrayborder" />
                </div>
              )}
            </div>
          </>
        )
      }
      {
        user?.permissions?.includes(
          "provider_settings.edit_calendar_view_settings"
        ) && (
          <div className="flex flex-row gap-2 justify-end items-end p-3 border-t border-gray-200">
            {/* <div className="flex flex-row gap-3 justify-end items-center w-full">
          <button
            // className="px-4 py-2 font-bold text-white bg-gray-400 rounded-md"
            className="w-28  font-semibold p-2 border-[2px] rounded-md bg-subtleblue border-primaryblue text-primaryblue whitespace-nowrap"
            onClick={() => {
              handleEditClick(null);
            }}
          >
            Cancel
          </button>
          <button
            // className="px-4 py-2 font-bold text-white rounded-md bg-primaryblue"
            className="p-2 font-semibold text-white border-[2px] rounded-md w-28  bg-primaryblue whitespace-nowrap border-primaryblue"
            onClick={upsertProviderConstraint}
          >
            Save
          </button>
        </div> */}
            {/* <div className="flex justify-between items-center px-6 py-4 w-full border-t border-gray-200"> */}

            {/* {sele} */}

            <div className="flex gap-2">
              <button
                className="px-4 py-2 text-gray-700 rounded-md border border-gray-300 hover:bg-gray-100"
                onClick={() => {
                  handleEditClick(null);
                }}
              >
                Cancel
              </button>
              {availabilityType == "global" ? (
                <button
                  className="px-4 py-2 text-white bg-blue-600 rounded-md hover:bg-blue-700"
                  onClick={upsertProviderConstraint}
                >
                  Save
                </button>
              ) : (
                !(availabilityType === "custom" &&
                  selectedWeeklyDateRange &&
                  !isEditMode) && <button
                    disabled={(
                      availabilityType === "custom" &&
                      selectedWeeklyDateRange &&
                      !isEditMode
                    )}
                    className={`px-4 py-2 text-white bg-blue-600 rounded-md hover:bg-blue-700 disabled:cursor-not-allowed disabled:opacity-50`}
                    onClick={() => {
                      if (!user?.permissions?.includes('provider_settings.edit_weekly_settings')) {
                        return;
                      }
                      if (!selectedWeeklyDateRange?.id) {
                        setIsSaveAsTemplateModalOpen(true);
                        setTemplateName("");
                      } else {


                        setIsSaveAsTemplateModalOpen(true);
                        const formattedStart = selectedWeeklyDateRange
                          ? moment(selectedWeeklyDateRange.start_date).format(
                            "DD MMM YYYY"
                          )
                          : moment(weeklyStartDate).format("DD MMM YYYY");
                        const formattedEnd = selectedWeeklyDateRange
                          ? moment(selectedWeeklyDateRange.end_date).format(
                            "DD MMM YYYY"
                          )
                          : moment(weeklyEndDate).format("DD MMM YYYY");
                        const defaultTemplateName = `${details?.name} - ${formattedStart} to ${formattedEnd} availability`;
                        setTemplateName(
                          selectedWeeklyDateRange?.template_name ||
                          defaultTemplateName
                        );
                      }
                    }}
                  >
                  {(selectedWeeklyDateRange?.id == null && activeTab == 0) ? 'Create Template' : 'Save changes'}
                </button>
              )}
              {/* </div> */}
            </div>
          </div>
        )
      }
      <Snackbar
        onClose={handleClose}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        open={open}
        autoHideDuration={3000}
        message={message ? message : "Something went wrong"}
        severity="error"
      >
        <Alert
          onClose={handleClose}
          severity={severity ? severity : "error"}
          variant="filled"
          sx={{ width: "100%" }}
        >
          {message ? message : "Something went wrong"}
        </Alert>
      </Snackbar>
    </ReusableModal >
  );
};

const modalOverlayStyle = {
  position: "fixed",
  top: 0,
  left: 0,
  width: "100%",
  height: "100%",
  backgroundColor: "rgba(0, 0, 0, 0.5)",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  zIndex: 1000,

};

const modalStyle = {
  backgroundColor: "#fff",
  padding: "10px 20px 10px 20px",
  borderRadius: "8px",
  boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
  maxWidth: '65vw'
};

export default ProviderSettingsModal;

// Geographic Coverage Component
export const GeographicCoverageSection = ({
  selectedDay,
  dayPreferences,
  setDayPreferences,
  providerId,
  fetchProviderZipCodes,
  disabled = false,
  marketId
}) => {
  const [searchTerm, setSearchTerm] = useState("");
  const [expandedSections, setExpandedSections] = useState(new Set());
  const [coverageData, setCoverageData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [showZipModal, setShowZipModal] = React.useState({ status: false, zips: [] });



  // Fetch coverage data on mount
  useEffect(() => {
    const fetchCoverageData = async () => {
      try {
        setIsLoading(true);
        const { data } = await fetchProviderZipCodes({ providerId, marketId }).unwrap();
        setCoverageData(data || []);
      } catch (error) {
        console.error("Error fetching coverage data:", error);
        setCoverageData([]);
      } finally {
        setIsLoading(false);
      }
    };

    if (providerId) {
      fetchCoverageData();
    }
  }, [providerId, fetchProviderZipCodes, marketId]);

  const allZipCodes = new Set();
  const flattenZipCodes = (data) => {
    data.forEach((item) => {
      if (item.zipCode) {
        allZipCodes.add(item.zipCode);
      }
      if (item.cities) {
        flattenZipCodes(item.cities);
      }
      if (item.counties) {
        flattenZipCodes(item.counties);
      }
    });
  };
  flattenZipCodes(coverageData);

  // Show this day's own zip_codes, same as appointment_type_ids. Inheriting "All Days"
  // zip codes for an unconfigured day is handled up front by the copy-on-visit effect
  // (defaultZipCodes) when the day is first selected, so no fallback is needed here.
  const currentZipCodes =
    selectedDay === "ALL"
      ? dayPreferences?.ALL?.zip_codes || []
      : (dayPreferences?.[selectedDay]?.zip_codes || []);
  const selectedZipCodes = new Set(currentZipCodes);

  const toggleSection = (sectionId) => {
    setExpandedSections((prev) => {
      const newSet = new Set(prev);
      if (newSet.has(sectionId)) {
        newSet.delete(sectionId);
      } else {
        newSet.add(sectionId);
      }
      return newSet;
    });
  };

  const handleZipCodeToggle = (zipCode, isChecked) => {
    setDayPreferences((prev) => {
      const prevZipCodes = prev?.[selectedDay]?.zip_codes || [];
      let newZipCodes;

      if (isChecked) {
        // Only add if not already present
        if (!prevZipCodes.includes(zipCode)) {
          newZipCodes = [...prevZipCodes, zipCode];
        } else {
          newZipCodes = prevZipCodes;
        }
      } else {
        newZipCodes = prevZipCodes.filter((zip) => zip !== zipCode);
      }

      return {
        ...prev,
        [selectedDay]: {
          ...prev?.[selectedDay],
          zip_codes: newZipCodes,
          zone_ids: [], // Clear zones when using zip codes
        },
      };
    });
  };

  const handleBulkZipCodeToggle = (zipCodes, isChecked) => {
    setDayPreferences((prev) => {
      const prevZipCodes = prev?.[selectedDay]?.zip_codes || [];
      let newZipCodes;

      if (isChecked) {
        // Add all zip codes that aren't already selected
        const zipCodesSet = new Set(prevZipCodes);
        zipCodes.forEach((zip) => zipCodesSet.add(zip));
        newZipCodes = Array.from(zipCodesSet);
      } else {
        // Remove all the zip codes
        const zipCodesToRemove = new Set(zipCodes);
        newZipCodes = prevZipCodes.filter((zip) => !zipCodesToRemove.has(zip));
      }

      return {
        ...prev,
        [selectedDay]: {
          ...prev?.[selectedDay],
          zip_codes: newZipCodes,
          zone_ids: [], // Clear zones when using zip codes
        },
      };
    });
  };

  const handleSelectAll = (isChecked) => {
    const newZipCodes = isChecked ? Array.from(allZipCodes) : [];

    setDayPreferences((prev) => ({
      ...prev,
      [selectedDay]: {
        ...prev?.[selectedDay],
        zip_codes: newZipCodes,
        zone_ids: [], // Clear zones when using zip codes
      },
    }));
  };

  const isAllSelected =
    allZipCodes.size > 0 && selectedZipCodes.size === allZipCodes.size;
  const isSomeSelected =
    selectedZipCodes.size > 0 && selectedZipCodes.size < allZipCodes.size;

  const term = searchTerm.trim().toLowerCase();
  const matchCityOrZip = (item) =>
    (item.city && item.city.toLowerCase().includes(term)) ||
    (item.zipCode && item.zipCode.includes(searchTerm.trim()));
  const matchCounty = (item) =>
    item.county && item.county.toLowerCase().includes(term);
  const matchState = (item) =>
    item.state && item.state.toLowerCase().includes(term);

  const filteredData = (data) => {
    if (!data) return [];
    return data.filter((item) => {
      // City level (has zipCode): match city OR zip
      if (item.zipCode) {
        if (!term) return true;
        return matchCityOrZip(item);
      }

      // County level (has cities): match county OR any city under it
      if (item.cities) {
        const hasMatchingCities = filteredData(item.cities).length > 0;
        if (!term) return true;
        return matchCounty(item) || hasMatchingCities;
      }

      // State level (has counties): match state OR any county under it
      if (item.counties) {
        const hasMatchingCounties = filteredData(item.counties).length > 0;
        if (!term) return true;
        return matchState(item) || hasMatchingCounties;
      }

      return false;
    });
  };

  // When county name matches search, show all data under it; otherwise show filtered children
  const getChildrenToDisplay = (item) => {
    if (item.counties) return filteredData(item.counties);
    if (item.cities) {
      if (term && matchCounty(item)) return item.cities;
      return filteredData(item.cities);
    }
    return [];
  };

  // Zip count from currently filtered/displayed children (for dynamic badge when searching)
  const getFilteredChildZipCodes = (item) => {
    if (item.zipCode) return [item.zipCode];
    if (item.counties) {
      const filtered = filteredData(item.counties);
      return filtered.flatMap((child) => getFilteredChildZipCodes(child));
    }
    if (item.cities) {
      if (term && matchCounty(item)) return getAllChildZipCodes(item);
      const filtered = filteredData(item.cities);
      return filtered.flatMap((child) => getFilteredChildZipCodes(child));
    }
    return [];
  };

  const renderTreeItem = (item, level = 1) => {
    // Get unique ID based on item type
    const itemId = item.zipCode || item.county || item.state;
    const isExpanded = expandedSections.has(itemId);
    const hasChildren =
      (item.counties && item.counties.length > 0) ||
      (item.cities && item.cities.length > 0);

    if (item.zipCode) {
      // City/Zip code level
      const isSelected = selectedZipCodes.has(item.zipCode);

      return (
        <div
          key={item.zipCode}
          className={`border-b border-gray-100 last:border-b-0 ${level === 3
            ? "bg-gray-50 border-l-4 border-gray-300"
            : level === 2
              ? "bg-white border-l-2 border-gray-200"
              : "bg-gray-100"
            }`}
        >
          <div className="flex gap-2 items-center px-3 py-2 transition-colors cursor-default hover:bg-blue-50">
            <span className="w-4 h-4"></span>
            <input
              type="checkbox"
              disabled={disabled}
              className="w-4 h-4 text-blue-600 rounded focus:ring-blue-500"
              checked={isSelected}
              onChange={(e) =>
                handleZipCodeToggle(item.zipCode, e.target.checked)
              }
            />
            <span
              className={`flex-1 ${level === 3
                ? "text-gray-600 text-sm"
                : level === 2
                  ? "text-gray-700"
                  : "text-gray-900 font-medium"
                }`}
            >
              {item.city}
            </span>
            <span className="px-2 py-1 text-xs font-medium text-blue-800 bg-blue-100 rounded">
              {item.zipCode}
            </span>
          </div>
        </div>
      );
    } else {
      // State or County level
      const childZips = getAllChildZipCodes(item);
      const selectedChildCount = childZips.filter((zip) =>
        selectedZipCodes.has(zip)
      ).length;
      const isAllChildrenSelected =
        childZips.length > 0 && selectedChildCount === childZips.length;
      const isSomeChildrenSelected =
        selectedChildCount > 0 && selectedChildCount < childZips.length;

      const itemName = item.state || item.county;
      const children = item.counties || item.cities;
      const filteredZipCount = getFilteredChildZipCodes(item).length;

      return (
        <div
          key={itemId}
          className={`border-b border-gray-200 last:border-b-0 ${level === 1 ? "bg-gray-100" : "bg-white"
            }`}
        >
          <div
            className={`flex items-center gap-2 px-3 py-2 ${hasChildren ? "cursor-pointer hover:bg-blue-50" : "cursor-default"
              } transition-colors`}
            onClick={() => hasChildren && toggleSection(itemId)}
          >
            {hasChildren && (
              <span
                className={`w-4 h-4 flex items-center justify-center text-gray-500 transition-transform ${isExpanded ? "rotate-90" : ""}`}
              >
                ▶
              </span>
            )}
            {!hasChildren && <span className="w-4 h-4"></span>}
            <input
              type="checkbox"
              disabled={disabled}
              className="w-4 h-4 text-blue-600 rounded focus:ring-blue-500"
              checked={isAllChildrenSelected}
              ref={(el) => {
                if (el) {
                  el.indeterminate = isSomeChildrenSelected;
                }
              }}
              onChange={(e) => {
                handleBulkZipCodeToggle(childZips, e.target.checked);
              }}
              onClick={(e) => e.stopPropagation()}
            />
            <span
              className={`flex-1 ${level === 1 ? "text-gray-900 font-medium" : "text-gray-700"
                }`}
            >
              {itemName}
            </span>
            {filteredZipCount > 0 && (
              <span className="px-2 py-1 text-xs font-medium text-gray-700 bg-gray-200 rounded">
                {filteredZipCount} zip code{filteredZipCount !== 1 ? "s" : ""}
              </span>
            )}
          </div>

          {hasChildren && isExpanded && (
            <div className="ml-4 border-l border-gray-200">
              {getChildrenToDisplay(item).map((child) =>
                renderTreeItem(child, level + 1)
              )}
            </div>
          )}
        </div>
      );
    }
  };

  const getAllChildZipCodes = (item) => {
    const zips = [];
    if (item.zipCode) {
      zips.push(item.zipCode);
    }
    if (item.cities) {
      item.cities.forEach((child) => {
        zips.push(...getAllChildZipCodes(child));
      });
    }
    if (item.counties) {
      item.counties.forEach((child) => {
        zips.push(...getAllChildZipCodes(child));
      });
    }
    return zips;
  };

  // Add this effect to auto-expand sections when searching
  useEffect(() => {
    if (!searchTerm.trim()) {
      setExpandedSections(new Set());
      return;
    }

    const term = searchTerm.trim().toLowerCase();
    const matchCityOrZip = (item) =>
      (item.city && item.city.toLowerCase().includes(term)) ||
      (item.zipCode && item.zipCode.includes(searchTerm.trim()));
    const matchCounty = (item) =>
      item.county && item.county.toLowerCase().includes(term);
    const matchState = (item) =>
      item.state && item.state.toLowerCase().includes(term);

    const expandSectionsWithMatches = (data, parentIds = []) => {
      const sectionsToExpand = new Set();

      data.forEach((item) => {
        const itemId = item.zipCode || item.county || item.state;
        let matchesSearch = false;
        if (item.zipCode) {
          matchesSearch = matchCityOrZip(item);
        } else if (item.cities) {
          matchesSearch = matchCounty(item);
        } else if (item.counties) {
          matchesSearch = matchState(item);
        }

        if (matchesSearch) {
          parentIds.forEach((parentId) => sectionsToExpand.add(parentId));
          sectionsToExpand.add(itemId);
        }

        if (item.counties) {
          const countyMatches = expandSectionsWithMatches(item.counties, [
            ...parentIds,
            itemId,
          ]);
          if (countyMatches.size > 0) {
            sectionsToExpand.add(itemId);
            countyMatches.forEach((id) => sectionsToExpand.add(id));
          }
        }

        if (item.cities) {
          const cityMatches = expandSectionsWithMatches(item.cities, [
            ...parentIds,
            itemId,
          ]);
          if (cityMatches.size > 0) {
            sectionsToExpand.add(itemId);
            cityMatches.forEach((id) => sectionsToExpand.add(id));
          }
        }
      });

      return sectionsToExpand;
    };

    const sectionsToExpand = expandSectionsWithMatches(coverageData);
    setExpandedSections(sectionsToExpand);
  }, [searchTerm, coverageData]);
  return (
    <div className="mb-6">
      <ReusableModal
        open={showZipModal?.status}
        title="Coverage"
        onClose={() => {
          setShowZipModal({ status: false, zips: [] })
        }}
      >
        <div className="min-w-[45vw] max-w-[45vw] p-3 ">
          <h2 className="mb-3 text-lg font-semibold">Zip Codes</h2>
          <div
            className="text-gray-700 max-h-[400px] overflow-y-auto p-2 rounded-md border border-gray-200 bg-gray-50"
          >
            {selectedZipCodes.size > 0 ? (
              <p className="leading-relaxed whitespace-normal break-words">
                {Array.from(selectedZipCodes).join(", ")}

              </p>
            ) : (
              <p className="italic text-gray-500">No Zip codes available.</p>
            )}
          </div>
        </div>
      </ReusableModal>
      <h3 className="mb-4 text-base font-semibold">
        Geographic Coverage{" "}
        {selectedDay !== "ALL"
          ? `for ${selectedDay[0] + selectedDay.substring(1).toLowerCase()}`
          : ""}
      </h3>
      <div className="bg-[#4285f4] text-white px-4 py-2 rounded-md text-sm font-semibold mb-3">
        Custom Coverage
      </div>
      <div className="px-3 py-2 mb-3 bg-blue-50 rounded-lg border border-blue-200">
        <div className="mb-1 text-sm font-semibold text-blue-800">
          Selected Coverage
        </div>
        <div className="text-sm text-blue-600">
          {selectedZipCodes.size === 0
            ? "No zip codes selected"
            : selectedZipCodes.size === allZipCodes.size
              ? `All ${selectedZipCodes.size} zip codes selected`
              : `${selectedZipCodes.size} of ${allZipCodes.size} zip codes selected`}
        </div>
        {selectedZipCodes.size > 0 && (
          <div className="flex flex-wrap gap-1 mt-2">
            {Array.from(selectedZipCodes)
              .slice(0, 5)
              .map((zip) => (
                <span
                  key={zip}
                  className="inline-flex items-center px-2 py-1 text-xs text-blue-800 bg-blue-100 rounded-full"
                >
                  {zip}
                </span>
              ))}
            {selectedZipCodes.size > 5 && (
              <span className="text-xs text-blue-600 cursor-pointer" onClick={() => {
                setShowZipModal({ status: true })
              }}>
                +{selectedZipCodes.size - 5} more
              </span>
            )}
          </div>
        )}
      </div>

      <div className="space-y-4">
        <div>
          <input
            type="text"
            disabled={disabled}
            className="px-3 w-full h-10 text-gray-900 rounded-lg border border-gray-300 outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 placeholder:text-gray-500"
            placeholder="Search by city, zip code, or county..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
        </div>

        <div className="px-3 py-2 bg-gray-50 rounded-lg border border-gray-300">
          <label className="flex gap-2 items-center text-sm font-medium text-gray-700 cursor-pointer">
            <input
              type="checkbox"
              disabled={disabled}
              className="w-4 h-4 text-blue-600 rounded focus:ring-blue-500"
              checked={isAllSelected}
              ref={(el) => {
                if (el) {
                  el.indeterminate = isSomeSelected;
                }
              }}
              onChange={(e) => handleSelectAll(e.target.checked)}
            />
            Select all zip codes
          </label>
        </div>

        <div className="overflow-y-auto max-h-80 bg-white rounded-lg border border-gray-300">
          {isLoading ? (
            <div className="py-8 text-center text-gray-500">
              <div className="flex flex-col gap-2 items-center">
                <div className="w-8 h-8 rounded-full border-4 border-blue-600 animate-spin border-t-transparent"></div>
                <span>Loading coverage data...</span>
              </div>
            </div>
          ) : (
            <>
              {filteredData(coverageData).map((item) => renderTreeItem(item))}

              {filteredData(coverageData).length === 0 && (
                <div className="py-8 text-center text-gray-500">
                  No matching zip codes found
                </div>
              )}
            </>
          )}
        </div>
      </div>
    </div>
  );
};
